/* ═══ THEME JS — progressive enhancement only. Everything works without it. ═══
   Modules: cart drawer, variant picker, gallery, collection page (view toggle,
   filter sheet, facets, load more, quick add, price slider), predictive
   search, wishlist, accordions.
   Each binds by data-attribute so a section can be added or removed freely.   */
(function () {
  'use strict';

  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn); };
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Enhancement is CONDITIONAL. Every module below checks this before it takes
     a form or a link away from the browser; when it is false the server-rendered
     form posts and the link navigates, exactly as with JS off. Feature-detect,
     never sniff a user agent. */
  var CAN_AJAX = !!(window.fetch && window.Promise && window.DOMParser &&
                    window.URLSearchParams && window.FormData &&
                    window.history && window.history.replaceState);

  /* Polite announcer. `#toast-mount` in layout/theme.liquid is an aria-live
     region but has no styles at all, so writing into it prints visible text
     under the footer. This uses `.visually-hidden`, which base.css already
     defines, so announcing costs no new CSS. */
  var Live = {
    node: null,
    say: function (msg) {
      if (!msg) return;
      if (!Live.node) {
        var n = document.createElement('p');
        n.className = 'visually-hidden';
        n.setAttribute('role', 'status');
        n.setAttribute('aria-live', 'polite');
        document.body.appendChild(n);
        Live.node = n;
      }
      /* Cleared first — an identical string is not re-announced otherwise. */
      Live.node.textContent = '';
      setTimeout(function () { Live.node.textContent = msg; }, 60);
    }
  };

  /* Trap Tab inside an open dialog. Same rule as the nav drawer and the
     subscribe popup — a keyboard user must not tab out behind aria-modal. */
  function trapTab(e, panel) {
    if (e.key !== 'Tab' || !panel) return;
    var f = $$(FOCUSABLE, panel).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }


  /* ── Header metrics — publish the REAL stuck height ────────────────────────
     --header-h is every sticky offset on the page (.fnd__tabs, .cart__aside,
     .c-side) and the base of --scroll-offset. tokens.css and responsive.css
     can only declare it per breakpoint, and the header's height is not a step
     function of the breakpoint: the bar wraps, so it stands 242px at 360 and
     182px at 640-749 with no guide breakpoint in between to hang a value on.
     Measure it instead — the same answer, for the same reason, as setMegaTop
     below — and leave the CSS ladder as the no-JS fallback.

     ZERO when the wrapper is not sticky. responsive.css releases the header in
     phone landscape (guide §4), and a 182px offset with nothing stuck would
     pin the Finder's tab row halfway down an empty screen — the exact bug the
     old `inset-block-start: 0` was written to avoid.

     Ceil, not round: half a pixel short of the header's real height is a hair
     of scrolling page showing in the seam under it.

     No feedback loop is possible: nothing inside .site-header reads
     --header-h, so writing it can never change the height being measured.
     Checked before wiring the ResizeObserver. */
  var HeaderMetrics = {
    init: function () {
      /* Before the header's own early return: the two measurements are
         independent, and a page could have one and not the other. */
      HeaderMetrics.buyBar();
      var header = $('.site-header');
      var wrap = header && header.parentElement;
      if (!header || !wrap) return;
      var last = null;
      function publish() {
        var stuck = false;
        try { stuck = window.getComputedStyle(wrap).position === 'sticky'; }
        catch (e) { return; }
        var h = stuck ? Math.ceil(header.getBoundingClientRect().height) : 0;
        if (h === last) return;
        last = h;
        document.documentElement.style.setProperty('--header-h', h + 'px');
      }
      publish();
      on(window, 'resize', publish);
      on(window, 'orientationchange', publish);
      /* The logo is an <img> and both faces are self-hosted, so the header can
         still grow after DOMContentLoaded. */
      on(window, 'load', publish);
      if (window.ResizeObserver) {
        try { new window.ResizeObserver(publish).observe(header); }
        catch (e) { /* the listeners above still cover the common cases */ }
      }
    },

    /* ── The sticky buy bar's real height ─────────────────────────────────────
       `body:has(.sticky-buy-bar)` in responsive.css reserves room for this bar
       with `var(--sticky-buy-h, 76px)`, and NOTHING IN THE REPO EVER SET THAT
       NAME — the read was its only occurrence, so 76px was the only value it
       ever took.

       Measured on teznplz.com 4 Oct 2026 at 320 and 390px, a real clearance
       PDP with a compare-at pair included: 76.66px in every case the store
       actually renders, so the live correction is 76px → 77px. TNP's prices
       are two-digit dollars and do not wrap. On clones of the bar with LONGER
       strings substituted ("$1,499.99 CAD" over "$1,299.99 CAD") it goes to
       102.31px, and 127.97px with a "Save X" line — a contingency, not a
       current defect, and the reason this is measured rather than declared:
       the height is content-dependent, so a longer currency string or a
       translated label turns a 0.66px error into a 26px one silently.
       (An earlier version of this comment stated the 26px as if it were the
       live case. It is not; it was a clone with prices TNP does not charge.)

       Same reason, and the same shape, as --header-h above: the height is not
       a step function of the breakpoint, so measure it and leave the CSS
       value as the no-JS fallback.

       THIS BAR NEEDS MORE THAN WINDOW EVENTS, unlike the header. Variants
       repaints `.sticky-buy-bar__price` in place on every variant change (see
       Variants, below), so picking a variant that is on sale can take the bar
       from one line to two with no resize, orientationchange or load to hang a
       listener on. TWO things cover that: the ResizeObserver below, and a
       direct `syncBuyBar()` call at the repaint itself. The direct call is
       deliberate belt-and-braces — the observer is the kind of dependency that
       is easy to assume and hard to notice failing, and it could not be
       exercised where this was verified (the browser pane does not deliver
       ResizeObserver callbacks at all: a control observer on a plain div never
       fired even its guaranteed initial one). The sale case does not rest on
       it.

       No feedback loop: the bar is `position: fixed`, so the body padding this
       value feeds cannot change the bar's own height. The `h === last` guard
       would terminate one anyway.

       Ceil, for the same reason as the header: 76.66 reserved as 76 leaves
       two thirds of a pixel of page under the bar. */
    buyBar: function () {
      var bar = $('.sticky-buy-bar');
      if (!bar) return;
      var last = null;
      function publish() {
        /* ⚠️ DO NOT REINTRODUCE AN `offsetParent === null` VISIBILITY TEST HERE.
           offsetParent is ALWAYS null for a `position: fixed` element, which
           this bar is — so that check reported the bar hidden on a phone where
           it was 76.66px tall, published 0px, and cut body's reserved space
           from 132px to 56px. That buries the bottom of the page under the buy
           bar, which is the regression the comment in responsive.css was
           written about. Caught in the harness before it shipped.

           The rect alone is already the correct answer: a `display: none`
           element (the bar is `.show-mobile`, hidden at ≥750, where the rule
           that reads this is out of play anyway) reports every rect value as
           0, so hidden publishes 0px without a special case. */
        var h = Math.ceil(bar.getBoundingClientRect().height);
        if (h === last) return;
        last = h;
        document.documentElement.style.setProperty('--sticky-buy-h', h + 'px');
      }
      /* Exposed so Variants can republish the instant it repaints the price,
         rather than leaving that case to the observer alone. */
      HeaderMetrics.syncBuyBar = publish;
      publish();
      on(window, 'resize', publish);
      on(window, 'orientationchange', publish);
      on(window, 'load', publish);
      if (window.ResizeObserver) {
        try { new window.ResizeObserver(publish).observe(bar); }
        catch (e) { /* the listeners above still cover resize and load */ }
      }
    },

    /* Replaced by buyBar() when there is a bar on the page; a no-op otherwise,
       so callers never have to check. */
    syncBuyBar: function () {}
  };

  /* ── Nav: mobile drawer + mega panels ──────────────────────────────────────
     §5.3 makes keyboard open/close REQUIRED, not optional — hover alone fails
     keyboard and touch users. Triggers are real <button>s so Enter/Space work
     for free; this adds Esc, outside-click and the drawer focus trap.        */
  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var Nav = {
    init: function () {
      var drawer = $('[data-nav-drawer]'), scrim = $('[data-nav-scrim]');
      var opener = $('[data-nav-open]');

      /* The drawer is `aria-modal="true"`, which modern screen readers honour
         by ignoring everything outside it — but `aria-modal` is a PROMISE, not
         an enforcement, and it does nothing for a sighted keyboard user whose
         browser does not implement it. `inert` is the enforcement: it removes
         the subtree from the a11y tree AND from sequential focus, in the
         engine rather than in the AT.

         Applied to the header and <main> rather than to <body>, because the
         drawer and its scrim are children of body and inerting their own
         ancestor would inert them too. Feature-detected: `inert` is Safari
         15.5+/Chrome 102+, and where it is missing the focus trap below is
         still the backstop it has always been. */
      var outside = [$('#main'), $('.site-header')].filter(Boolean);
      var CAN_INERT = 'inert' in HTMLElement.prototype;

      function setDrawer(open) {
        if (!drawer) return;
        drawer.hidden = !open;
        if (scrim) scrim.hidden = !open;
        document.documentElement.classList.toggle('nav-open', open);
        if (opener) opener.setAttribute('aria-expanded', String(open));
        if (CAN_INERT) {
          outside.forEach(function (el) { el.inert = open; });
        }
        if (open) { var f = drawer.querySelector(FOCUSABLE); if (f) f.focus(); }
        else if (opener) opener.focus();
      }

      on(opener, 'click', function () { setDrawer(true); });
      on($('[data-nav-close]'), 'click', function () { setDrawer(false); });
      on(scrim, 'click', function () { setDrawer(false); });

      /* Focus trap — a keyboard user must not tab out behind an aria-modal. */
      on(drawer, 'keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = $$(FOCUSABLE, drawer).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      /* Mega panels. */

      /* ⚠️ CLOSING A PANEL FROM OUTSIDE USED TO LEAVE IT PINNED.
         This walked the DOM and hid panels directly, which skipped each
         trigger's own `pinned` flag. So after you clicked one menu and then
         opened another, the first one was hidden but still believed it was
         pinned, and your NEXT click on it read "already pinned" and closed it
         again — one whole click that did nothing. Panels register themselves
         here instead, and closing goes through the same setOpen() the trigger
         uses, so the flag and any pending close timer are cleared with it. */
      var megas = [];
      function closeAllMega(except) {
        megas.forEach(function (m) { if (m.trigger !== except) m.close(); });
      }

      /* Hover is an ENHANCEMENT (guide §4 + §9): hover-open only where the
         pointer is a real one, click/Enter/tap everywhere. */
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      /* Grace period before a hover-opened panel closes. See the 4px note on
         the mouseleave handler below. */
      var CLOSE_DELAY = 220;

      /* A fixed panel needs a real offset, and the nav's bottom edge moves with
         the announcement bar, the breakpoint and the sticky header. Measure it
         once and on resize rather than hard-coding a number that goes stale. */
      var navEl = $('.site-nav');
      var headerEl = $('.site-header');
      function setMegaTop() {
        if (!navEl) return;
        /* ⚠️ `position: fixed` IS NOT ALWAYS RELATIVE TO THE VIEWPORT.
           An ancestor with `filter`, `backdrop-filter`, `transform` or
           `will-change` becomes the containing block instead — and
           .site-header carries `backdrop-filter: blur(18px)`. So a plain
           viewport offset put the panel 61px too low, floating over the hero
           with a stripe of page showing through the gap.
           Measuring from the containing block's own top is correct whether or
           not that blur is ever removed. */
        var origin = headerEl ? headerEl.getBoundingClientRect().top : 0;
        var b = Math.round(navEl.getBoundingClientRect().bottom - origin);
        document.documentElement.style.setProperty('--mega-top', b + 'px');
        /* Room actually left under the nav. Guide §4 caps the panel at
           `100svh - var(--header-h)`, but that formula ignores the
           announcement bar: with it up, the panel starts 222px down while
           --header-h is 176, so a 570px panel still ran 179px past the bottom
           of a 613px-tall window and its last rows of links were unreachable.
           Measure the real gap instead; the calc() stays as the fallback. */
        var space = Math.round(window.innerHeight - navEl.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--mega-space', Math.max(200, space) + 'px');
      }
      setMegaTop();
      on(window, 'resize', setMegaTop);
      on(window, 'scroll', setMegaTop);

      $$('[data-mega-trigger]').forEach(function (trigger) {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;

        /* ⚠️ HOVER AND CLICK WERE CANCELLING EACH OTHER OUT.
           A real pointer fires mouseenter BEFORE click. Hover opened the panel,
           then the click read aria-expanded="true" and toggled it shut — so to
           a mouse user the menu flashed open and closed and looked completely
           dead. A scripted .click() never reproduced it, because nothing
           dispatched mouseenter first; only a real click at real coordinates
           showed it.

           `pinned` is the fix. Hover opens UNPINNED, so leaving closes it again.
           A click PINS it, so it stays until a second click, Esc, or a click
           outside. That is also what a mouse user expects: move over it to
           peek, click to keep it. */
        var pinned = false;
        var closeTimer = null;

        function cancelClose() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        }

        function setOpen(open) {
          cancelClose();
          trigger.setAttribute('aria-expanded', String(open));
          panel.hidden = !open;
          if (open) closeAllMega(trigger);
          if (!open) pinned = false;
        }

        function scheduleClose() {
          cancelClose();
          closeTimer = setTimeout(function () { if (!pinned) setOpen(false); }, CLOSE_DELAY);
        }

        megas.push({ trigger: trigger, close: function () { setOpen(false); } });

        /* Does this trigger go anywhere? sections/header.liquid renders a
           parent item as an <a href> when its menu url is real, and keeps a
           <button> when the url is blank or "#" ("Extras" in the live menu).
           The account panel in the icon row is a <button> too. Read the tag,
           not the class — both wear `site-nav__link`. */
        var href = trigger.tagName === 'A' ? trigger.getAttribute('href') : null;
        var navigates = !!href && href !== '#';

        on(trigger, 'click', function (e) {
          /* A <button> has nowhere to go, so the click is a pure toggle —
             unchanged behaviour, and the account panel depends on it. */
          if (!navigates) {
            if (pinned) { setOpen(false); return; }   /* second click closes */
            pinned = true;                            /* first click pins it open */
            setOpen(true);
            return;
          }

          /* ⚠️ FROM HERE DOWN THE TRIGGER IS A LINK, AND A LINK'S DEFAULT IS
             TO NAVIGATE. Nothing below may call preventDefault() unless it is
             deliberately spending the click on opening the panel instead.

             ⚠️ EVERY PATH THAT NAVIGATES MUST cancelClose() FIRST. A hover
             close is deferred by CLOSE_DELAY (220ms) and the click that
             leaves the page happens well inside that window, so the timer is
             still armed when navigation starts. Come back with the browser's
             Back button and the page can be restored from the bfcache —
             timers, closures and all — and that stale callback then runs
             against a panel whose `pinned` flag and `aria-expanded` no longer
             agree with what is on screen. Killing the timer on the way out is
             one line and removes the whole class of it.

             Enter (and Space, on the account button) used to be "already
             covered" because a click on a <button> is all a keyboard ever
             produces. That is no longer the whole story: Enter on a link
             fires a click that NAVIGATES.

             ⚠️ THAT IS THE DECISION, NOT AN OVERSIGHT — see the focus handler
             below. Enter goes to the parent page; the panel is reached by
             focusing the trigger, not by pressing Enter twice. Do not add a
             second-Enter trick here.

             `detail === 0` is what makes it hold on a touch device, where the
             two-tap rule below would otherwise eat the first Enter and the
             keyboard would need two presses to follow a link it can see. A
             keyboard-generated click reports `detail === 0`; every real tap
             and mouse click reports at least 1. */
          if (e.detail === 0) { cancelClose(); return; }

          /* Fine pointer: hover (below) has already opened the panel, so the
             click itself is free to be a link. Deliberately no preventDefault
             and deliberately no touching of `pinned` — the documented
             mouseenter-before-click race is only dangerous when the click
             reads or flips state that hover just set, and this branch does
             neither. The page is leaving anyway. */
          if (canHover) { cancelClose(); return; }

          /* Coarse pointer: there is no hover, so the panel has no other way
             to open. First tap spends itself opening and pinning it; the
             second tap on the same item finds it pinned and navigates.
             Note the focus handler below fires first on a tap and opens the
             panel UNPINNED, which is why this tests `pinned` and not
             `panel.hidden` — hidden would already be false and the first tap
             would navigate. */
          if (!pinned) {
            e.preventDefault();
            pinned = true;
            setOpen(true);        /* setOpen() cancels the timer itself */
            return;
          }
          cancelClose();          /* second tap — this one leaves the page */
        });

        /* ⚠️ THIS IS HOW THE KEYBOARD OPENS A PANEL. SETTLED, NOT A GAP.
           Making parents links changed what Enter does: on a <button> it
           fired `click` and toggled the panel, on an <a href> it navigates.
           Both are needed — the guide (§4, §9) requires the panel to be
           keyboard-openable, and the owner asked for a parent item to reach
           its own page. Splitting them across two different interactions is
           the resolution:

             focus  → opens the panel, so Tab walks straight into its links
             Enter  → goes to the parent page

           Do not "fix" this by making Enter toggle the panel and asking for a
           second Enter to navigate. It was considered and rejected: it makes
           every category cost two keystrokes and it contradicts what the link
           announces itself to be.

           Unpinned, so the `focusout` below still closes it the moment focus
           leaves the item, and the two handlers do not fight — checked
           against both orders that matter: tabbing trigger → first panel link
           keeps relatedTarget inside the item, so nothing closes; tabbing off
           the last panel link lands outside it and closes.

           Anchors only. Putting this on a <button> trigger WOULD fight the
           pointer: a mouse click focuses the button and then fires click, so
           focus would open the panel and the click would immediately toggle
           it shut again — the same flash the `pinned` flag was invented to
           cure. An anchor is safe because its click either navigates or is
           handled by the tap rule, and neither path closes. */
        if (navigates) {
          on(trigger, 'focus', function () {
            cancelClose();
            if (!pinned) setOpen(true);
          });
        }

        /* ⚠️ THE 4px STRIP THAT MADE EVERY SUBMENU UNREACHABLE BY MOUSE.
           `.site-nav > .container` carries `padding-block: 4px`, so the <li>
           stops 4px ABOVE the nav's bottom edge while the fixed panel starts
           exactly ON it — measured at 1440px: <li> bottom 218, panel top 222.
           The panel is a DOM child of the <li>, so hovering the panel itself
           counts as inside the item — but those 4px in between belong to the
           CONTAINER, not the item. Moving the cursor down towards a link the
           pointer passed over the container, `mouseleave` fired, and the panel
           closed before the cursor ever arrived. Logged live: `mouseleave
           rel=DIV.container` at y=220, panel hidden by y=226. The menu opened
           on hover and there was no way to click anything in it.
           Two defences, because one is not enough:
             • CSS bridges the strip while the panel is open — see
               `.site-nav__item:has(...)::after` in base.css — so mouseleave
               does not fire at all on a straight path down.
             • the close is DEFERRED by CLOSE_DELAY, which covers a diagonal
               path that leaves the item sideways, and a browser without
               `:has()`. Re-entering the item OR the panel (a descendant, so it
               fires the item's own mouseenter) cancels the pending close. */
        var item = trigger.closest('.site-nav__item');
        if (canHover) {
          on(item, 'mouseenter', function () { cancelClose(); if (!pinned) setOpen(true); });
          on(item, 'mouseleave', function () { if (!pinned) scheduleClose(); });
        }

        /* Leaving the panel by keyboard closes it. */
        on(item, 'focusout', function (e) {
          if (!item.contains(e.relatedTarget)) setOpen(false);
        });
      });

      on(document, 'keydown', function (e) {
        if (e.key !== 'Escape') return;
        closeAllMega();
        if (drawer && !drawer.hidden) setDrawer(false);
      });

      on(document, 'click', function (e) {
        /* `[data-mega-host]` is the account panel in the icon row — it uses the
           same trigger/panel contract but does not live in .site-nav. */
        if (!e.target.closest('.site-nav__item') && !e.target.closest('[data-mega-host]')) closeAllMega();
      });
    }
  };

  /* ── Shipping strip — permanent, no module ─────────────────────────────
     The owner asked for the strip to stay up (26 Sep 2026), so the dismiss
     button, its click handler and the `tnp_announce_*` localStorage flag were
     removed together with the section's pre-paint `hidden` script. A stale
     flag left in a returning visitor’s browser is simply never read again. */

  /* ── Submit-once guard — for forms that POST and reload ───────────────────
     Shopify's contact form has no AJAX path: it posts and the browser replaces
     the document. Between those two moments the button still looks idle, so a
     second click sends a second email. On a slow connection that window is
     seconds long.

     ⚠️ THE TIMING IS THE WHOLE TRICK. A button disabled DURING its own click
     or submit handler is not a successful submit button, so the browser leaves
     its name/value out and — for a form that depends on it — can send nothing
     at all. The disable therefore happens on the next task, after the browser
     has already taken the submission.

     Opt-in by attribute so this can never touch a form that needs to be
     submitted twice. Delegated, so it survives a re-rendered section.

     With JS off nothing here runs and the form posts exactly as before. */
  var SubmitOnce = {
    init: function () {
      on(document, 'submit', function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        var btn = form.querySelector('[data-submit-once]');
        if (!btn || btn.disabled) return;
        setTimeout(function () {
          /* Validation can abort a submit after this handler ran; only lock the
             button once the form is actually leaving. */
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
          /* And anything else that cancelled it — an app, an extension, a later
             listener. A button left disabled on a form that never sent is the
             same dead end as the double-send, pointing the other way. */
          if (e.defaultPrevented) return;
          var label = btn.getAttribute('data-submitting-label');
          if (label) {
            /* Keep the box from collapsing as the word changes under it. */
            btn.style.minWidth = btn.getBoundingClientRect().width + 'px';
            btn.textContent = label;
          }
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          form.setAttribute('aria-busy', 'true');
        }, 0);
      });
    }
  };

  /* ── Quantity stepper — the input is the source of truth ──────────────────
     Delegated, not bound per element. The cart drawer and a re-rendered cart
     page inject their own steppers after load, and the previous one-shot
     binding at DOMContentLoaded left every one of those dead: the buttons were
     announced as controls and did nothing. */
  var Qty = {
    init: function () {
      on(document, 'click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-qty-down], [data-qty-up]') : null;
        if (!btn) return;
        var wrap = btn.closest('[data-qty]');
        var input = wrap ? $('.qty__input', wrap) : null;
        if (!input) return;
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = Math.max(1, v + (btn.hasAttribute('data-qty-up') ? 1 : -1));
        /* The input stays the source of truth; everything else listens here. */
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };

  /* ── Filter fallback — an APPLY BUTTON, never an auto-submit ───────────────
     This used to bind `form.submit()` to any change on the facet form. That
     is WCAG 3.2.2 (On Input): the form holds the sort <select> as well as every
     checkbox, and arrowing through a select fires `change` per option on
     several browser/AT pairs, so the page navigated mid-selection. Even when it
     worked, every tick was a full reload that dumped focus back to the top of
     the document — a keyboard user could never reach the second filter.

     `CollFilters` replaces it outright by rendering in place and leaving focus
     alone. This module only covers the case where `CollFilters` could not take
     over (no fetch/DOMParser, or the markup drifted), and it does so with an
     explicit control, not a change handler.

     The button is not invented here: with scripting on, a <noscript> element's
     children are parsed as TEXT, so the section's own Liquid-authored Apply
     button can be lifted straight out of it. Same copy, same classes, no new
     string and no new CSS.

     ⚠️ Runs AFTER `CollFilters` (see the init array) so the claim is already set. */
  var Filters2 = {
    init: function () {
      var form = $('#FacetForm');
      if (!form || form.hasAttribute('data-ajax-filters')) return;
      if ($('[data-fallback-apply]', form)) return;

      var source = $('noscript', form);
      var holder = document.createElement('div');
      holder.setAttribute('data-fallback-apply', '');
      if (source && source.textContent.indexOf('<button') > -1) holder.innerHTML = source.textContent;
      if (!$('button', holder)) return;   /* nothing safe to surface — leave the form alone */
      if (source && source.parentNode) source.parentNode.insertBefore(holder, source);
      else form.appendChild(holder);
    }
  };


  /* ── Subscribe popup ───────────────────────────────────────────────────────
     ⚠️ IT MUST NEVER FIGHT THE AGE GATE. While `.age-unverified` is on <html>
     the gate owns the screen; the popup waits for the `tnp:age-accepted` event
     that age-gate.js dispatches, and only then starts its delay. A capture
     modal stacked on top of an 18+ gate is two dialogs competing for one
     keyboard, and the gate must win.

     Dismissal is permanent per device, like the announcement bar, and every
     storage call is wrapped — a private window must not throw here.          */
  var SubscribePopup = {
    init: function () {
      var root = document.documentElement;
      var popup = $('[data-subscribe-popup]');
      if (!popup) return;

      var KEY   = 'tnp_popup_dismissed';
      var panel = $('.popup__panel', popup);
      var scrim = $('[data-popup-scrim]', popup);

      /* WCAG 2.4.3. This popup appears on a timer, so it takes focus from
         whatever the shopper was doing; hiding it then dropped focus to <body>
         and restarted them at the top of the document. Remember where they
         were and put them back, the same way the nav drawer does. */
      var returnTo = null;

      function dismissed() {
        try { return !!localStorage.getItem(KEY); } catch (e) { return false; }
      }
      function dismiss() {
        popup.hidden = true;
        try { localStorage.setItem(KEY, '1'); } catch (e) { /* session only */ }
        /* Only if it is still in the document and still focusable. */
        if (returnTo && document.contains(returnTo) && returnTo.focus) returnTo.focus();
        returnTo = null;
      }
      function reveal() {
        if (root.classList.contains('age-unverified')) return;
        if (dismissed()) return;
        returnTo = document.activeElement;
        popup.hidden = false;
        var f = panel && panel.querySelector(FOCUSABLE);
        if (f) f.focus();
      }
      function arm() {
        var d = parseInt(popup.getAttribute('data-delay'), 10);
        setTimeout(reveal, (isNaN(d) ? 8 : d) * 1000);
      }

      /* A non-AJAX form post reloads the page. If the success message is on
         screen, show it regardless of delay or prior dismissal. */
      /* The success branch used to reveal unconditionally — the one path that
         could stack this modal on top of the age gate, which the header of this
         module says must never happen. Defer it like every other path. */
      if ($('[data-popup-success]', popup)) {
        if (root.classList.contains('age-unverified'))
          document.addEventListener('tnp:age-accepted', function () { popup.hidden = false; }, { once: true });
        else popup.hidden = false;
      }
      else if (root.classList.contains('age-unverified'))
        document.addEventListener('tnp:age-accepted', arm, { once: true });
      else arm();

      on($('[data-popup-close]', popup), 'click', dismiss);
      on(scrim, 'click', dismiss);
      on(popup, 'keydown', function (e) {
        if (e.key === 'Escape') { dismiss(); return; }
        if (e.key !== 'Tab' || !panel) return;
        var f = $$(FOCUSABLE, panel).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
  };

  /* ── Cart drawer ───────────────────────────────────────────────────────────
     The drawer is NOT a second cart UI. It renders `sections/main-cart.liquid`
     through the Section Rendering API, so the discreet-packaging line, the
     free-shipping bar and every money string stay in Liquid. A JSON-driven
     drawer built from /cart.js would have had to invent customer-facing copy
     and format currency in JS — that drops the §4 compliance line and breaks
     Hard Rule 8 the first time the store sells in a second currency.

     ⚠️ CHECKOUT IS NEVER POSTED. Nothing here submits the cart form. The
     rendered markup's `/checkout` LINK navigates on its own — see the header
     comment in sections/main-cart.liquid for why the POST path 503s.

     On /cart itself the header cart link is deliberately left alone: you are
     already looking at the cart, and injecting a second copy of the section
     would duplicate its <h1>, its input ids and its [data-cart-subtotal].  */
  var Cart = {
    /* ⚠️ The Section Rendering API wants the section FILE name, not the key in
       templates/cart.json. Verified against the live store:
         /cart?section_id=main-cart  → 200
         /cart?section_id=main_cart  → 404
       The 404 path fails silently — the drawer just navigates to /cart — so a
       wrong value here looks like "the drawer was never built". */
    SECTION: 'main-cart',
    panel: null, scrim: null, body: null, opener: null,
    chain: null, timer: null,

    init: function () {
      $$('[data-cart-open]').forEach(function (b) { on(b, 'click', Cart.onOpen); });
      on(document, 'keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

      /* Delegated on purpose. The cart markup is replaced wholesale after every
         change, so per-node binding would either go stale or double up. */
      on(document, 'click', function (e) {
        var rm = e.target.closest ? e.target.closest('.cart__remove') : null;
        if (!rm || !CAN_AJAX) return;        /* no fetch → the link navigates */
        var root = Cart.rootOf(rm);
        if (!root) return;
        var target = Cart.targetFromHref(rm.getAttribute('href'));
        if (!target) return;                 /* unrecognised href → let it navigate */
        e.preventDefault();
        var row = rm.closest('.cart__line');
        if (row) row.hidden = true;          /* optimistic; the render reconciles */
        Cart.change(target, 0, root);
      });

      on(document, 'change', function (e) {
        var input = e.target;
        if (!input.classList || !input.classList.contains('qty__input')) return;
        if (!CAN_AJAX) return;
        var root = Cart.rootOf(input);
        if (!root) return;
        /* The stepper fires one change per tap, so coalesce: send what the
           inputs say once the user stops, not once per tap. */
        clearTimeout(Cart.timer);
        Cart.timer = setTimeout(function () { Cart.syncQty(root); }, 350);
      });

      /* With JS off this form posts `updates[]` to /cart, which is the
         documented fallback and still works. With JS on, keep the page. */
      on(document, 'submit', function (e) {
        var form = e.target;
        if (!form.hasAttribute || !form.hasAttribute('data-cart-page') || !CAN_AJAX) return;
        e.preventDefault();
        var root = Cart.rootOf(form);
        if (root) Cart.syncQty(root);
      });

      Cart.decorate(document);
    },

    /* Which cart is this control in — the page section, or the drawer? */
    rootOf: function (el) {
      return el.closest('[data-cart-drawer-body]') ||
             el.closest('[data-section-type="main-cart"]');
    },

    /* WHICH line a Remove link points at, taken from the markup rather than
       from a DOM position we guessed.

       ⚠️ `item.url_to_remove` emits EITHER form. On this store it is
       `?id=41560711790679:b471fe01…&quantity=0` — a line item KEY, not an
       index — and the original `line=` regex returned 0 for it. 0 is falsy, so
       the handler fell through to "let it navigate" and every Remove click was
       a full page load while the quantity stepper next to it updated in place.
       Nothing errored; it just quietly stopped being an AJAX cart.

       /cart/change.js accepts either, so both are read and passed through as
       they are. A key must stay a STRING — parseInt would truncate it at the
       colon and change a different line. */
    targetFromHref: function (href) {
      var byLine = /[?&]line=(\d+)/.exec(href || '');
      if (byLine) return { line: parseInt(byLine[1], 10) };
      var byId = /[?&]id=([^&]+)/.exec(href || '');
      if (byId) return { id: decodeURIComponent(byId[1]) };
      return null;
    },

    onOpen: function (e) {
      if (!CAN_AJAX) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      /* The gate owns the screen until it is accepted. Nothing opens over it. */
      if (document.documentElement.classList.contains('age-unverified')) return;
      if (document.body.classList.contains('template-cart')) return;
      /* The drawer's own painted copy contains a [data-cart-page] form, so this
         must ignore it — otherwise reopening the drawer once it has loaded
         mistakes itself for the cart page and navigates away. */
      var pageCart = $('[data-cart-page]');
      if (pageCart && !pageCart.closest('[data-cart-drawer-body]')) return;
      if (!Cart.mount()) return;
      e.preventDefault();
      Cart.opener = e.currentTarget;
      Cart.open();
      Cart.load();
    },

    /* Built once, lazily — nothing is added to the DOM until the shopper asks
       for the cart, so this cannot delay first paint or the gate. */
    mount: function () {
      if (Cart.panel) return Cart.panel;
      var host = document.getElementById('cart-drawer-mount');
      if (!host) return null;

      var scrim = document.createElement('div');
      scrim.className = 'scrim';
      scrim.hidden = true;

      var panel = document.createElement('aside');
      /* `.drawer` carries the shared chrome; `.drawer--cart` is the hook for the
         cart-specific CSS (right-hand side, wider) that base.css still owes it.
         Without that modifier it simply opens as a nav-width left drawer, which
         is usable but not what the spec asks for — see the report. */
      panel.className = 'drawer drawer--cart';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.hidden = true;

      var head = document.createElement('div');
      head.className = 'drawer__head cluster';

      /* Copy taken from markup Liquid already rendered, so this file never
         invents a customer-facing string and never bypasses the `t` filter. */
      var title = document.createElement('span');
      title.className = 'drawer__title';
      var label = $('[data-cart-open] .visually-hidden');
      title.textContent = label ? label.textContent.trim() : 'Cart';
      panel.setAttribute('aria-label', title.textContent);

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'icon-btn tap';
      close.setAttribute('data-cart-close', '');
      /* Reuse the nav drawer's close control: same icon set (Hard Rule 4), same
         translated label, no inline <svg> invented here. */
      var navClose = $('[data-nav-close]');
      if (navClose) close.innerHTML = navClose.innerHTML;
      else close.textContent = 'Close';

      head.appendChild(title);
      head.appendChild(close);

      var body = document.createElement('div');
      body.setAttribute('data-cart-drawer-body', '');

      panel.appendChild(head);
      panel.appendChild(body);
      host.appendChild(scrim);
      host.appendChild(panel);

      on(close, 'click', Cart.close);
      on(scrim, 'click', Cart.close);
      on(panel, 'keydown', function (e) { trapTab(e, panel); });

      Cart.scrim = scrim; Cart.panel = panel; Cart.body = body;
      return panel;
    },

    open: function () {
      document.documentElement.classList.add('cart-open');
      if (!Cart.panel) return;
      Cart.scrim.hidden = false;
      Cart.panel.hidden = false;
      var f = Cart.panel.querySelector(FOCUSABLE);
      if (f) f.focus();
    },

    close: function () {
      if (!Cart.panel || Cart.panel.hidden) {
        document.documentElement.classList.remove('cart-open');
        return;
      }
      document.documentElement.classList.remove('cart-open');
      Cart.scrim.hidden = true;
      Cart.panel.hidden = true;
      if (Cart.opener) Cart.opener.focus();
    },

    load: function () {
      Cart.body.setAttribute('aria-busy', 'true');
      fetch('/cart?section_id=' + Cart.SECTION, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.text(); })
        .then(function (html) { Cart.paint(html, Cart.body); })
        .catch(function () { window.location.href = '/cart'; });
    },

    /* Find the one line whose input no longer matches what the server rendered
       and send that absolute quantity. Re-running after each render converges,
       and a server-side clamp (out of stock) stops the loop rather than fighting
       it, because the re-render re-stamps the expected value. */
    syncQty: function (root) {
      var inputs = $$('.cart__line .qty__input', root);
      var i, target = -1;
      for (i = 0; i < inputs.length; i++) {
        if (String(inputs[i].value) !== inputs[i].getAttribute('data-rendered-qty')) { target = i; break; }
      }
      if (target < 0) return;
      var q = parseInt(inputs[target].value, 10);
      if (isNaN(q) || q < 0) q = 0;
      Cart.change({ line: target + 1 }, q, root);
    },

    /* Serialised, not aborted: /cart/change.js takes an ABSOLUTE quantity, so
       out-of-order responses would silently resurrect an old value. */
    change: function (target, qty, root) {
      root.setAttribute('aria-busy', 'true');
      /* `target` is {line:N} or {id:'<key>'} — change.js takes either, and the
         caller knows which one the markup gave it. */
      var payload = {
        quantity: qty,
        sections: Cart.SECTION + ',header',
        sections_url: '/cart'
      };
      if (target.line) payload.line = target.line;
      else payload.id = target.id;
      Cart.chain = (Cart.chain || Promise.resolve()).then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) throw new Error('cart change ' + r.status);
          return r.json();
        }).then(function (data) {
          var s = data.sections || {};
          Cart.paint(s[Cart.SECTION], root);
          Cart.paintHeader(s.header);
        }).catch(function () {
          /* Degrade honestly: go to the real cart rather than show a lie. */
          window.location.href = '/cart';
        });
      });
      return Cart.chain;
    },

    paint: function (html, root) {
      root.removeAttribute('aria-busy');
      var section = html ? Cart.parse(html) : null;
      if (!section) { window.location.href = '/cart'; return; }
      /* In the drawer the heading and the fixed mobile bar are duplicates of
         chrome the drawer already has. */
      if (root.hasAttribute('data-cart-drawer-body')) {
        var h = section.querySelector('.section__heading');
        if (h && h.parentNode) h.parentNode.removeChild(h);
        var bar = section.querySelector('.sticky-buy-bar');
        if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      }
      root.innerHTML = '';
      while (section.firstChild) root.appendChild(section.firstChild);
      Cart.decorate(root);
      Cart.announce(root);
    },

    parse: function (html) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-section-type="main-cart"]');
    },

    /* Only the count bubble is swapped, not the whole header — replacing the
       header element would throw away Nav's listeners. */
    paintHeader: function (html) {
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-open]');
      var live = $('[data-cart-open]');
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    },

    decorate: function (root) {
      $$('[data-cart-subtotal]', root).forEach(function (n) {
        n.setAttribute('aria-live', 'polite');
      });
      $$('.cart__line .qty__input', root).forEach(function (n) {
        n.setAttribute('data-rendered-qty', n.value);
      });
    },

    /* The subtotal node is replaced on every render, so an aria-live attribute
       on it alone would never fire. The standalone region does the announcing;
       the attribute stays for anything reading the markup directly. */
    announce: function (root) {
      var sub = $('[data-cart-subtotal]', root);
      if (!sub) return;
      var row = sub.closest('.cart__row');
      var label = row ? row.firstElementChild : null;
      var prefix = (label && label !== sub) ? label.textContent.trim() + ' ' : '';
      Live.say(prefix + sub.textContent.trim());
    }
  };

  /* ── Variant picker ────────────────────────────────────────────────────────
     Two passes on purpose. The first is instant and local: the hidden `id`
     field, the URL, the gallery and the disabled state all come from the
     variants JSON already on the page. The second re-renders the section for
     the chosen variant and swaps in price, stock and the button label.

     The second pass exists because money MUST come from Liquid (Hard Rule 8) —
     the variants JSON carries prices in cents with no format, and there is no
     money formatter on the page to turn 4500 into the shopper's currency.

     ⚠️ history.replaceState, never pushState. A variant swap is not a
     navigation; pushState would make Back walk the shopper through every
     colour they tried instead of returning to the collection.               */
  var Variants = {
    init: function () {
      $$('[data-variant-picker]').forEach(function (picker) {
        on(picker, 'change', function () { Variants.select(picker); });
      });
    },

    /* Parsed on demand — a PDP with many variants should not pay for the JSON
       parse until the shopper actually touches an option. */
    data: function (picker) {
      if (picker.variantData) return picker.variantData;
      try { picker.variantData = JSON.parse(picker.getAttribute('data-variants') || '[]'); }
      catch (e) { picker.variantData = []; }
      return picker.variantData;
    },

    chosen: function (picker) {
      var out = [];
      $$('input[type="radio"]:checked', picker).forEach(function (r) {
        var pos = parseInt((r.name || '').replace('option', ''), 10);
        if (!isNaN(pos)) out[pos - 1] = r.value;
      });
      return out;
    },

    match: function (picker) {
      var want = Variants.chosen(picker);
      var all = Variants.data(picker);
      for (var i = 0; i < all.length; i++) {
        var v = all[i], ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] !== undefined && v.options[j] !== want[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    },

    select: function (picker) {
      var form = picker.closest('form');
      var variant = Variants.match(picker);
      var idField = form ? $('[data-variant-id]', form) : $('[data-variant-id]');
      var add = form ? $('.pdp__add', form) : null;

      /* No such combination. Clear the id so the form cannot post a variant the
         shopper did not choose, and block the submit. */
      if (!variant) {
        if (idField) idField.value = '';
        if (add) add.disabled = true;
        return;
      }

      if (idField) idField.value = variant.id;
      if (add) add.disabled = !variant.available;

      if (CAN_AJAX) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.pathname + url.search);
      }

      /* The variant JSON names its media, so the gallery reuses the thumbnail
         rail's own swap rather than a second image code path. */
      if (variant.featured_media && variant.featured_media.id) {
        var thumb = $('[data-gallery-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) Gallery.show(thumb);
      }

      Variants.refresh(variant.id);
    },

    refresh: function (id) {
      if (!CAN_AJAX) return;
      var section = $('[data-section-type="main-product"]');
      if (!section) return;
      if (Variants.pending) Variants.pending.abort();
      var ctl = window.AbortController ? new AbortController() : null;
      Variants.pending = ctl;

      var url = window.location.pathname +
                '?variant=' + encodeURIComponent(id) +
                /* data-section-id is the JSON template KEY (main_product) and
                   404s. The API wants the file name, which is data-section-type. */
                '&section_id=' + section.getAttribute('data-section-type');

      fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('variant ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          /* Inner HTML only. Replacing the elements would drop the listeners
             and move focus off whatever the shopper just clicked. */
          ['[data-price]', '[data-stock]'].forEach(function (sel) {
            var next = doc.querySelector(sel), cur = $(sel, section);
            if (next && cur) cur.innerHTML = next.innerHTML;
          });
          var freshAdd = doc.querySelector('.pdp__add'), curAdd = $('.pdp__add', section);
          if (freshAdd && curAdd) {
            curAdd.textContent = freshAdd.textContent.trim();
            curAdd.disabled = freshAdd.hasAttribute('disabled');
          }
          var freshBar = doc.querySelector('.sticky-buy-bar__price'), curBar = $('.sticky-buy-bar__price');
          if (freshBar && curBar) {
            curBar.innerHTML = freshBar.innerHTML;
            /* This swap changes the bar's content and fires no resize event,
               so any height change would go unreserved until the next one. At
               TNP's current price lengths it does not change the height
               (76.66px measured live either way); with longer strings it does
               (102.31px on a clone). Republish here rather than rely on the
               ResizeObserver alone — cheap, and correct whichever is true. */
            HeaderMetrics.syncBuyBar();
          }
          var freshSticky = doc.querySelector('[data-sticky-add]'), curSticky = $('[data-sticky-add]');
          if (freshSticky && curSticky) {
            curSticky.textContent = freshSticky.textContent.trim();
            curSticky.disabled = freshSticky.hasAttribute('disabled');
          }
          var stock = $('[data-stock]', section);
          if (stock) Live.say(stock.textContent.trim());
        })
        .catch(function () { /* Local pass already applied; leave the page be. */ });
    }
  };

  /* ── Gallery ───────────────────────────────────────────────────────────────
     ONE list of slides, two presentations (spec §10.2):
       ≤640   native scroll-snap swipe carousel + dot indicators
       641+   the same slides collapse onto a single stage; the thumb rail
              chooses which one is shown

     Both are CSS. responsive.css decides which slide displays; this module
     only moves `data-current`. Never replace native scrolling with a JS
     carousel — it breaks momentum, the back-swipe, accessibility and keyboard
     users. So there is no transform here, no autoplay, no scroll hijacking:
     the scroll listener only READS position to light the matching dot.

     No <img> is built or cloned either. Every slide arrived from Liquid with
     its own srcset, so changing slides costs no image code path at all. The
     previous module cloned the 90px THUMBNAIL onto the main stage and had to
     patch `sizes` back up afterwards to stop the browser painting a 90px
     asset at full width.

     Slides, dots and thumbs all loop over `product.media limit: 8` in the
     section, so index N means the same image in all three. That shared index
     is the whole state — there is nothing else to keep in sync. */
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (fn) { return setTimeout(fn, 16); };

  var Gallery = {
    init: function () {
      $$('.pdp__gallery').forEach(function (gallery) {
        var stage = $('[data-gallery-main]', gallery);
        if (!stage) return;

        var slides = $$('[data-gallery-slide]', stage);
        if (slides.length < 2) return;

        /* Thumbs are real <button>s, so Enter and Space already work and
           nothing here touches the tab order.

           `warm` is the price of not cloning images. Off mobile only one slide
           is displayed, so the rest are `loading="lazy"` AND `display:none`,
           which means the browser has not fetched them — click a thumb and the
           stage is blank while its image downloads. Warming on hover and focus
           starts that fetch while the pointer is still travelling, and the
           click handler warms again for touch and keyboard, where there is no
           hover to warm from. */
        $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
          on(thumb, 'click', function () { Gallery.show(thumb); });
          on(thumb, 'pointerenter', function () { Gallery.warm(gallery, thumb); });
          on(thumb, 'focus', function () { Gallery.warm(gallery, thumb); });
        });

        /* Liquid already marked the slide the shopper landed on — the selected
           variant's image, not blindly the first. Mirror it so the dots and
           thumbs cannot disagree with the stage on first paint. */
        var start = 0;
        slides.forEach(function (s, i) { if (s.hasAttribute('data-current')) start = i; });
        Gallery.mark(gallery, start);

        /* A snap scroll fires `scroll` dozens of times. Unthrottled, each one
           would measure every slide. */
        var queued = false;
        on(stage, 'scroll', function () {
          if (queued) return;
          queued = true;
          raf(function () {
            queued = false;
            Gallery.mark(gallery, Gallery.nearest(stage));
          });
        });
      });
    },

    /* Start the fetch for the slide a thumb points at. Flipping `loading` from
       lazy to eager begins the load even while the element is display:none;
       once eager it stays eager, so this costs one fetch per image at most. */
    warm: function (gallery, thumb) {
      var id = thumb.getAttribute('data-media-id');
      var slide = $('[data-gallery-slide][data-media-id="' + id + '"]', gallery);
      var img = slide ? $('img', slide) : null;
      if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    },

    /* Which slide is closest to the middle of the scrollport. Measured with
       getBoundingClientRect, not offsetLeft: `.media` makes every slide its
       own positioned ancestor, so offsetLeft is not relative to the stage —
       and rects stay correct in RTL, where scrollLeft does not. */
    nearest: function (stage) {
      var box = stage.getBoundingClientRect();
      var mid = box.left + (box.width / 2);
      var idx = 0, best = Infinity;
      $$('[data-gallery-slide]', stage).forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var d = Math.abs((r.left + (r.width / 2)) - mid);
        if (d < best) { best = d; idx = i; }
      });
      return idx;
    },

    /* The single state write: slide, dot and thumb, from one index. */
    mark: function (gallery, idx) {
      var id = '';
      $$('[data-gallery-slide]', gallery).forEach(function (s, i) {
        if (i === idx) { s.setAttribute('data-current', ''); id = s.getAttribute('data-media-id') || ''; }
        else s.removeAttribute('data-current');
      });
      $$('[data-gallery-dot]', gallery).forEach(function (d, i) {
        if (i === idx) d.setAttribute('data-current', '');
        else d.removeAttribute('data-current');
      });
      $$('[data-gallery-thumb]', gallery).forEach(function (t) {
        t.setAttribute('aria-current', String(!!id && t.getAttribute('data-media-id') === id));
      });
    },

    /* Called by a thumb click and by Variants.select when the chosen variant
       names its own media. */
    show: function (thumb) {
      var gallery = thumb.closest('.pdp__gallery');
      var stage = gallery ? $('[data-gallery-main]', gallery) : null;
      if (!stage) return;

      Gallery.warm(gallery, thumb);

      var id = thumb.getAttribute('data-media-id');
      var slides = $$('[data-gallery-slide]', stage);
      var idx = -1;
      slides.forEach(function (s, i) {
        if (idx < 0 && s.getAttribute('data-media-id') === id) idx = i;
      });
      if (idx < 0) return;

      Gallery.mark(gallery, idx);

      /* Mobile: the stage is a scroller, so move it too — picking a variant
         must not leave the shopper looking at the previous colour. scrollLeft
         and not scrollIntoView, which would also scroll the PAGE and throw the
         buy box off screen. Off mobile the stage does not overflow and this is
         a no-op. */
      if (stage.scrollWidth > stage.clientWidth) {
        stage.scrollLeft += slides[idx].getBoundingClientRect().left - stage.getBoundingClientRect().left;
      }
    }
  };

  /* ── Recently viewed ───────────────────────────────────────────────────────
     A per-BROWSER list of product ids, in localStorage and nowhere else. It is
     never sent to the store, an account or an analytics sink — on this
     catalogue a browsing history that follows someone to another device is a
     disclosure, not a feature (ACCOUNT-STRUCTURE.md, "Privacy").

     Read through the SEARCH route with an `id:` filter, which is the one way
     to turn a list of ids into rendered cards in a single request.

     localStorage can throw — private mode, blocked site data — so every access
     is wrapped and the row just does not appear. It is a convenience strip;
     nothing on the page depends on it. */
  var KEY = 'tnp_recent';
  var CAP = 12;

  var Recent = {
    read: function () {
      try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    },
    write: function (ids) {
      try { window.localStorage.setItem(KEY, JSON.stringify(ids.slice(0, CAP))); }
      catch (e) { /* nothing to do, and nothing depends on it */ }
    },

    init: function () {
      /* Record first: a PDP view counts even if the row below never renders. */
      var pdp = $('[data-section-type="main-product"]');
      var host = $('[data-recent]');
      var current = host && host.getAttribute('data-recent-current');

      if (pdp && current) {
        var ids = Recent.read().filter(function (id) { return String(id) !== String(current); });
        ids.unshift(String(current));
        Recent.write(ids);
      }

      if (!host || !CAN_AJAX) return;

      /* The product you are looking at is not "recently viewed" — it is the
         page. Drop it before building the query, not after rendering. */
      var list = Recent.read().filter(function (id) { return String(id) !== String(current); });
      if (!list.length) return;

      var q = list.slice(0, 8).map(function (id) { return 'id:' + id; }).join(' OR ');
      fetch(host.getAttribute('data-recent-url') + '&q=' + encodeURIComponent(q))
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recent]');
          if (!fresh || !fresh.querySelector('.grid-products')) return;
          host.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* stays absent */ });
    }
  };

  /* ── Predictive search ─────────────────────────────────────────────────────
     Suggestions under the header box. Spec §5.17.

     PROGRESSIVE, not a replacement. The header stays a real GET form: Enter
     submits to /search whether this module loaded, failed or was never reached.
     Nothing here calls preventDefault on the submit.

     Fetched by FILE name — `?section_id=predictive-search` — because the
     section does not live in a JSON template and so has no qualified id. The
     product recommendations row is the other case and uses `section.id`. Mixing
     the two 404s silently.

     Three things that are easy to get wrong and are handled here:
       - a request started later can ARRIVE first, painting stale suggestions
         over fresh ones. Each request carries a sequence number and a late
         reply is dropped.
       - the previous request is aborted rather than left running, so a fast
         typist does not hold six sockets open against the store.
       - ArrowDown moves a visual + aria-selected cursor WITHOUT moving focus.
         Focus stays in the input, which is what a combobox is; moving focus
         into the list breaks typing.                                        */
  var Search = {
    seq: 0,
    pending: null,
    timer: null,
    index: -1,

    pairs: [],
    /* Registered by other modules; see the call site in `run`. */
    decorators: [],

    /* ⚠️ THERE ARE TWO BOXES ON THE COLLECTION PAGE. The header's and the
       sidebar's (COLLECTION-PAGE-SPEC §7.1). This used to take the FIRST
       match of each selector, which wired the header's input to the header's
       panel and left the sidebar box as a plain form with no suggestions.

       Each input names its own panel through `aria-controls`, which the
       combobox pattern requires anyway, so the pairing comes from the markup
       rather than from document order. */
    init: function () {
      if (!CAN_AJAX) return;
      $$('[data-psearch-input]').forEach(function (input) {
        var mount = document.getElementById(input.getAttribute('aria-controls') || '');
        if (!mount || !mount.hasAttribute('data-psearch-mount')) return;
        Search.pairs.push({ input: input, mount: mount });
        Search.bind(input, mount);
      });
    },

    /* Only one panel may be open at a time: both are built from the same
       section, so two open panels means two elements sharing every id inside
       them, and `aria-activedescendant` then points at whichever the browser
       found first. */
    closeOthers: function (keep) {
      Search.pairs.forEach(function (p) {
        if (p.input !== keep) Search.close(p.input, p.mount);
      });
    },

    bind: function (input, mount) {
      on(input, 'focus', function () { Search.closeOthers(input); });

      on(input, 'input', function () {
        clearTimeout(Search.timer);
        var q = input.value.trim();
        if (q.length < 2) { Search.close(input, mount); return; }
        /* Debounced: a keystroke is not a query. */
        Search.timer = setTimeout(function () { Search.run(input, mount, q); }, 250);
      });

      on(input, 'keydown', function (e) {
        var open = input.getAttribute('aria-expanded') === 'true';
        if (e.key === 'Escape') { Search.close(input, mount); return; }
        if (!open) return;
        var items = $$('[data-psearch-item]', mount);
        if (!items.length) return;

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          /* -1 is a real position: the typed query itself. Arrowing past the
             last suggestion returns there rather than wrapping to the first,
             which is how a combobox lets you get back to what you typed.
             (The modulo this replaced evaluated to -1 for every keypress, so
             the cursor never moved at all.) */
          var step = e.key === 'ArrowDown' ? 1 : -1;
          var n = items.length;
          var next = Search.index + step;
          if (next >= n) next = -1;
          if (next < -1) next = n - 1;
          Search.index = next;
          Search.cursor(input, items);
        } else if (e.key === 'Enter' && Search.index > -1) {
          /* Only hijack Enter when a suggestion is actually highlighted —
             otherwise the form submits, which is the correct default. */
          e.preventDefault();
          var link = $('a', items[Search.index]);
          if (link) window.location.href = link.href;
        }
      });

      /* Clicking away closes it; clicking INSIDE must not, or the link never
         fires on a browser that blurs before it navigates. */
      on(document, 'click', function (e) {
        if (e.target === input || mount.contains(e.target)) return;
        Search.close(input, mount);
      });
    },

    run: function (input, mount, q) {
      var mine = ++Search.seq;
      if (Search.pending) Search.pending.abort();
      var ctl = window.AbortController ? new AbortController() : null;
      Search.pending = ctl;

      fetch(input.getAttribute('data-psearch-url') + '&q=' + encodeURIComponent(q),
            ctl ? { signal: ctl.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          if (mine !== Search.seq) return;              /* a later query won */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var panel = doc.querySelector('[data-psearch-panel]');
          if (!panel) return;
          mount.innerHTML = panel.innerHTML;
          /* ONE HOOK, for the Finder's client-rendered category column.
             It runs BEFORE the cursor is rebuilt, so the rows it inserts are
             in `[data-psearch-item]` when the arrow keys are wired up and the
             announcement below counts them. Anything else — the header box,
             the collection sidebar — has no decorator registered and reaches
             `if` with nothing to do. */
          for (var d = 0; d < Search.decorators.length; d++) {
            try { Search.decorators[d](input, mount, q); }
            catch (err) { console.error('[theme]', err); }
          }
          mount.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          Search.bindListbox(input, mount);
          Search.index = -1;
          Search.cursor(input, $$('[data-psearch-item]', mount));

          var n = $$('[data-psearch-item]', mount).length;
          var status = $('[data-psearch-status]', input.form || document);
          if (status) status.textContent = n
            ? n + ' suggestion' + (n === 1 ? '' : 's') + ' available.'
            : 'No suggestions.';
        })
        .catch(function () { /* Leave the box alone; Enter still searches. */ });
    },

    /* ⚠️ `aria-controls` HAS TO NAME THE LISTBOX ITSELF.
       Both comboboxes point `aria-controls` at their MOUNT — `psearch-results`
       in the header, `CollSearchResults` in the collection sidebar — but the
       element carrying `role="listbox"` is `.psearch__cols`, a CHILD of that
       mount, which also holds the "see all results" link. ARIA 1.2 wants the
       popup element named directly, so a screen reader following the reference
       landed on a plain <div> and the option list it was supposed to describe
       was one level further down.

       Re-pointed at paint time rather than in Liquid because the listbox does
       not exist until something is painted, and because the SAME markup is
       produced three ways (server section, Finder.paint, Finder.merge). The id
       is derived from the mount's own id, so the two boxes that coexist on a
       collection page can never collide. `close` puts the mount id back, so an
       idle combobox still references something real. */
    bindListbox: function (input, mount) {
      var box = $('[role="listbox"]', mount);
      if (!box) { if (mount.id) input.setAttribute('aria-controls', mount.id); return; }
      if (!box.id) box.id = (mount.id || 'psearch') + '-listbox';
      input.setAttribute('aria-controls', box.id);
    },

    cursor: function (input, items) {
      items.forEach(function (li, i) {
        var on_ = i === Search.index;
        li.setAttribute('aria-selected', String(on_));
        li.classList.toggle('is-active', on_);
      });
      var cur = items[Search.index];
      input.setAttribute('aria-activedescendant', cur ? cur.id : '');
      if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
    },

    close: function (input, mount) {
      clearTimeout(Search.timer);
      if (Search.pending) { Search.pending.abort(); Search.pending = null; }
      mount.hidden = true;
      mount.innerHTML = '';
      Search.index = -1;
      input.setAttribute('aria-expanded', 'false');
      if (mount.id) input.setAttribute('aria-controls', mount.id);
      input.removeAttribute('aria-activedescendant');
    }
  };

  /* ── Localization ──────────────────────────────────────────────────────────
     Submits the country/currency form on change. Deliberately NOT a generic
     `data-auto-submit` handler: that attribute also sits on the PLP sort
     select, where the CollFilters module already handles the change over AJAX, and
     a generic handler would fire both — every sort would become a reload AND a
     fetch. Scoped to its own attribute instead.

     The <noscript> button in the snippet is the no-JS path; nothing here is
     required for the form to work. */
  var Localization = {
    init: function () {
      $$('[data-localization-form]').forEach(function (form) {
        var select = $('select', form);
        if (!select) return;
        on(select, 'change', function () { form.submit(); });
      });
    }
  };

  /* ── Recommendations ───────────────────────────────────────────────────────
     Swaps Shopify's behaviour-based row in over the server-rendered fallback.

     The section is fetched by its FILE name — `?section_id=product-
     recommendations`. A JSON template key 404s here and does it silently, which
     is how three modules shipped degraded on this theme before.

     If anything goes wrong — no fetch, a 404, a network drop — the page keeps
     the collection fallback that Liquid already rendered. That is the whole
     failure mode: the row is never empty because JS did not finish.

     The response is a full section document; only its INNER markup is taken,
     so the outer <section> keeps its data attributes and the module cannot
     accidentally nest one section inside another on a second run. */
  var Recs = {
    init: function () {
      $$('[data-recs]').forEach(function (host) {
        var url = host.getAttribute('data-recs-url');
        if (!url || !CAN_AJAX) return;

        fetch(url)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-recs]');
            if (!fresh) return;
            /* Shopify returned no recommendations for this product. Keep the
               fallback rather than blanking a row the shopper can already see. */
            if (!fresh.querySelector('.grid-products')) return;
            host.innerHTML = fresh.innerHTML;
          })
          .catch(function () { /* fallback stays. */ });
      });
    }
  };

  /* ── Collection page + search results ─────────────────────────────────────
     COLLECTION-PAGE-SPEC.md §6–§8. Seven small modules, all ENHANCEMENT: with
     JS off the facet form is a GET form, the chips are links, Load more is an
     <a href="?page=N">, quick add is a link to the product and the sidebar
     stays in flow. Nothing below is required for the page to work.

     They share one lookup. The section file is `main-collection` on BOTH
     /collections/* and /search — templates/search.json points at it, per
     §7.1 — so `data-section-type` is the same string on either page and is
     also the id the Section Rendering API wants.

     ⚠️ SECTION RENDERING WANTS THE FILE NAME, NOT THE TEMPLATE KEY.
     `?section_id=main-collection` → 200; `?section_id=main_collection` → 404,
     and the 404 path fails silently. Reading it off the attribute is what
     keeps the two in step.                                                  */
  var Coll = {
    section: function () { return $('[data-section-type="main-collection"]'); },

    /* Add `section_id` to a URL that may or may not already have a query. */
    renderUrl: function (href, section) {
      return href + (href.indexOf('?') > -1 ? '&' : '?') +
             'section_id=' + section.getAttribute('data-section-type');
    },

    /* A plain left click on a link we mean to intercept. Everything else —
       middle click, cmd-click, a new tab — must behave like a normal link. */
    plainClick: function (e) {
      return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button);
    }
  };

  /* ── Grid / list toggle — §6.3 ─────────────────────────────────────────────
     The attribute is set on <html> BEFORE FIRST PAINT by the inline script in
     layout/theme.liquid; this only keeps the two buttons' aria-pressed in step
     and writes the choice back. Reading localStorage here instead would repaint
     the grid as a list in front of the shopper on every page load.

     localStorage THROWS in a private window with site data blocked — it does
     not return null — so every access is wrapped.                           */
  var CollView = {
    KEY: 'tnp:view',

    init: function () {
      on(document, 'click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-set-view]') : null;
        if (!b) return;
        CollView.set(b.getAttribute('data-set-view'));
      });
      CollView.sync();
    },

    set: function (v) {
      v = v === 'list' ? 'list' : 'grid';
      document.documentElement.setAttribute('data-view', v);
      try { localStorage.setItem(CollView.KEY, v); } catch (e) { /* session only */ }
      CollView.sync();
    },

    sync: function () {
      var v = document.documentElement.getAttribute('data-view') === 'list' ? 'list' : 'grid';
      $$('[data-set-view]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-set-view') === v));
      });
    }
  };

  /* ── Filter sheet (< 990) — §7.4, §11 ──────────────────────────────────────
     The sheet and the desktop sidebar are the SAME element; CSS decides which
     one it is and this module never asks the width. It only toggles an
     attribute that the sheet rules read, so at 990+ opening it is a no-op that
     cannot happen (the trigger is display:none).

     `role="dialog"` and `aria-modal` are set HERE, on open, and removed on
     close — a sidebar that is permanently a modal dialog lies to a screen
     reader at every width above 990.                                        */
  var CollSheet = {
    panel: null, scrim: null, trigger: null,

    isOpen: function () {
      return !!(CollSheet.panel && CollSheet.panel.hasAttribute('data-open'));
    },

    init: function () {
      var section = Coll.section();
      if (!section) return;
      CollSheet.panel = $('.c-side--sheet', section);
      CollSheet.scrim = $('.c-scrim', section);
      CollSheet.trigger = $('[data-open-sheet]', section);
      if (!CollSheet.panel || !CollSheet.trigger) return;

      on(document, 'click', function (e) {
        if (!e.target.closest) return;
        if (e.target.closest('[data-open-sheet]')) { CollSheet.open(); return; }
        if (e.target.closest('[data-close-sheet]')) { CollSheet.close(); return; }
        /* §7.4: on mobile nothing is applied until "Show results". */
        if (e.target.closest('[data-apply-sheet]')) {
          CollSheet.close();
          CollFilters.apply();
        }
      });

      on(document, 'keydown', function (e) {
        if (!CollSheet.isOpen()) return;
        if (e.key === 'Escape') { CollSheet.close(); return; }
        trapTab(e, CollSheet.panel);
      });
    },

    open: function () {
      var p = CollSheet.panel;
      if (!p || CollSheet.isOpen()) return;
      p.setAttribute('data-open', '');
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-modal', 'true');
      if (CollSheet.scrim) CollSheet.scrim.hidden = false;
      CollSheet.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('nav-open');   /* locks body scroll */
      /* ⚠️ Setting the attribute does NOT make the panel focusable in the same
         tick. Style recalculation is lazy, so `visibility` is still computed
         `hidden` when focus() runs and the call is silently ignored — the
         sheet opens with focus stranded on the trigger, behind the scrim.
         Reading offsetHeight forces the flush; it is the one place in this
         module where a deliberate reflow is the point. */
      void p.offsetHeight;

      /* ⚠️ AND THE REFLOW IS NOT ENOUGH. `visibility` is TRANSITIONED on this
         panel (responsive.css: `visibility 0s linear var(--dur)` closed,
         `visibility 0s` open). A property with a transition does not adopt its
         new value during a forced layout — the transition is started on the
         next style update — so `visibility` is still computed `hidden` for the
         rest of this tick and focus() is dropped exactly as before.

         Measured on the live theme 29 Sep 2026, real tap, clean load, three
         times: role=dialog and aria-modal=true were set, the panel painted,
         and document.activeElement was still `.c-filter-btn` — OUTSIDE the
         dialog, behind the scrim. trapTab only wraps focus that is already
         inside the panel, so the next Tab walked into the page underneath.

         So: try synchronously (free, and it wins once the panel is already
         visible), and otherwise retry on signals that are DELIVERED RATHER
         THAN RENDERED.

         ⚠️ THIS USED TO RETRY ON requestAnimationFrame, AND THAT WAS NOT
         VERIFIABLE. rAF is driven by "update the rendering", which the
         built-in browser pane does not run — rAF callbacks never fire there at
         all. So the retry could not have been what made the 29 Sep test pass;
         the synchronous attempt was, on that load, and the loop underneath it
         was never once exercised by the test that signed it off. It may well
         have worked in a real browser. "May well" is not a verification.

         `transitionend` and `setTimeout` are both delivered from the task
         queue, so they fire in the pane and in every browser, and the retry can
         actually be tested. transitionend is the exact signal — the panel
         becomes focusable when the visibility/transform transition finishes —
         and the two timers cover the cases where no transition runs at all
         (reduced motion sets --dur to ~0, and a transition that never starts
         never ends). */
      function land() {
        /* Closed again before focus landed — leave it alone. */
        if (!CollSheet.isOpen()) return;
        /* Already inside, by us or by the shopper: never steal it back. */
        if (p.contains(document.activeElement)) return;
        /* The close button BY NAME, not "the first focusable": the first match
           depends on markup order, and a panel opened with focus left outside
           it is a keyboard trap in the other direction. */
        var first = $('[data-close-sheet]', p) || $(FOCUSABLE, p);
        if (first) first.focus();
      }
      land();
      if (!p.contains(document.activeElement)) {
        p.addEventListener('transitionend', land, { once: true });
        setTimeout(land, 0);     /* no transition ran (reduced motion, --dur 0) */
        setTimeout(land, 150);   /* transition ran but ended before we listened */
      }
    },

    close: function () {
      var p = CollSheet.panel;
      if (!p || !CollSheet.isOpen()) return;
      p.removeAttribute('data-open');
      p.removeAttribute('role');
      p.removeAttribute('aria-modal');
      if (CollSheet.scrim) CollSheet.scrim.hidden = true;
      CollSheet.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('nav-open');
      CollSheet.trigger.focus();
    }
  };

  /* ── Facets — §7.4, §8 ────────────────────────────────────────────────────
     Form state → URL → Section Rendering API. The FORM stays the source of
     truth, so the URL is exactly what a no-JS GET submit would have produced
     and every filtered view is still linkable — the thing this page lost when
     it was hand-rolled elsewhere.

     Three parts of the page are repainted: the facet form, the toolbar and the
     results. The SEARCH BOX IS NOT, deliberately — replacing it would throw
     away whatever the shopper had half-typed and kill the predictive panel
     under their cursor.

     Everything is bound on the SECTION, not on the form or the select, because
     both of those nodes are replaced on every render and per-node listeners
     would go stale after the first click.                                   */
  var CollFilters = {
    pushed: false,
    pending: null,
    debounce: null,
    slow: null,

    init: function () {
      var section = Coll.section();
      if (!section || !CAN_AJAX) return;
      var form = $('#FacetForm', section);
      if (!form) return;

      /* Claim it before Filters2 initialises, or every change is a reload AND
         a fetch. The init array runs this first for exactly that reason. */
      form.setAttribute('data-ajax-filters', '');

      on(section, 'change', function (e) {
        var t = e.target;
        if (!t || !t.form || t.form.id !== 'FacetForm') return;
        if (t.type === 'number' || t.type === 'range') return;   /* see 'input' */
        if (CollSheet.isOpen()) return;         /* §7.4: wait for Show results */
        CollFilters.apply();
      });

      /* §7.3: price applies 400ms after the slider stops, or on blur/Enter. */
      on(section, 'input', function (e) {
        var t = e.target;
        if (!t || t.type !== 'number' || !t.form || t.form.id !== 'FacetForm') return;
        if (CollSheet.isOpen()) return;
        clearTimeout(CollFilters.debounce);
        CollFilters.debounce = setTimeout(CollFilters.apply, 400);
      });

      on(section, 'submit', function (e) {
        if (!e.target || e.target.id !== 'FacetForm') return;
        e.preventDefault();
        clearTimeout(CollFilters.debounce);
        CollFilters.apply();
      });

      /* Active chips and every Clear all. They are real <a>s to Shopify's own
         `url_to_remove`, so this only saves the round trip. */
      on(section, 'click', function (e) {
        var a = e.target.closest ? e.target.closest('[data-facet-link]') : null;
        if (!a || !a.getAttribute('href') || !Coll.plainClick(e)) return;
        e.preventDefault();
        if (CollSheet.isOpen()) CollSheet.close();
        CollFilters.go(a.getAttribute('href'));
      });

      /* Back should return to the previous filter state. Re-reading the URL
         from the server is the honest way to do it: it re-syncs the sidebar's
         checkboxes too, which an in-place render would have to replay by
         hand. */
      on(window, 'popstate', function () {
        if (CollFilters.pushed) window.location.reload();
      });
    },

    /* The URL a no-JS submit of this form would have produced. An EMPTY price
       bound must not enter it — Shopify reads `filter.v.price.gte=` as a real
       filter and returns nothing. */
    apply: function () {
      var section = Coll.section();
      if (!section) return;
      var form = $('#FacetForm', section);
      if (!form) return;
      var params = new URLSearchParams();
      /* FormData picks up the sort <select> even though it sits in the
         toolbar: it is associated by `form="FacetForm"`. */
      new FormData(form).forEach(function (value, key) {
        if (String(value).length) params.append(key, value);
      });
      var qs = params.toString();
      CollFilters.go(window.location.pathname + (qs ? '?' + qs : ''));
    },

    go: function (target) {
      var section = Coll.section();
      if (!section) { window.location.href = target; return; }

      /* §11: focus stays on the control you changed, matched by name + value. */
      var act = document.activeElement;
      var keep = act && act.name ? { name: act.name, value: act.value, type: act.type } : null;
      var open = CollFilters.openGroups(section);

      if (CollFilters.pending) CollFilters.pending.abort();
      var ctl = window.AbortController ? new AbortController() : null;
      CollFilters.pending = ctl;

      /* §6.5: "Max 300ms before showing it (skip if faster)". A bar that
         flashes on every click reads as breakage, so the class is delayed
         rather than the render. */
      section.setAttribute('aria-busy', 'true');
      clearTimeout(CollFilters.slow);
      CollFilters.slow = setTimeout(function () { section.classList.add('is-loading'); }, 300);

      fetch(Coll.renderUrl(target, section), {
        credentials: 'same-origin',
        signal: ctl ? ctl.signal : undefined
      })
        .then(function (r) { if (!r.ok) throw new Error('facets ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          CollFilters.done(section);

          var ok = CollFilters.swap(doc, section, '#FacetForm') &&
                   CollFilters.swap(doc, section, '.c-tools') &&
                   CollFilters.swap(doc, section, '[data-results]');
          /* Contract drifted — do a real navigation rather than a half render. */
          if (!ok) { window.location.href = target; return; }
          CollFilters.swapMore(doc, section);

          CollFilters.restoreGroups(section, open);
          CollView.sync();
          Wishlist.sync(section);            /* fresh cards render hearts unpressed */

          window.history.pushState({ tnpFacets: true }, '', target);
          CollFilters.pushed = true;

          if (keep) {
            var sel = '[name="' + (window.CSS && CSS.escape ? CSS.escape(keep.name) : keep.name) + '"]';
            var again = $$(sel, section).filter(function (el) {
              return keep.type === 'checkbox' ? el.value === keep.value : true;
            })[0];
            if (again) again.focus();
          }

          /* §11: announce that it changed, never HOW MANY — §0 forbids a
             count anywhere on this page, and that includes what is spoken.
             The string comes from markup Liquid rendered, so this file never
             invents a customer-facing sentence and never bypasses `t`. */
          var status = $('[data-results-status]', section);
          var label = $('[data-results-updated]', section);
          if (status && label) status.textContent = label.textContent.trim();
        })
        .catch(function (err) {
          CollFilters.done(section);
          if (err && err.name === 'AbortError') return;
          window.location.href = target;
        });
    },

    done: function (section) {
      clearTimeout(CollFilters.slow);
      section.removeAttribute('aria-busy');
      section.classList.remove('is-loading');
    },

    /* Replace one region's INNER markup, keeping the outer node — so its
       attributes, its aria-live region and any listener bound to it survive. */
    swap: function (doc, section, sel) {
      var next = doc.querySelector(sel);
      var cur = $(sel, section);
      if (!next || !cur) return false;
      cur.innerHTML = next.innerHTML;
      return true;
    },

    /* Load more is the one region that legitimately disappears: on the last
       page the section renders no wrapper at all. */
    swapMore: function (doc, section) {
      var next = doc.querySelector('[data-more-wrap]');
      var cur = $('[data-more-wrap]', section);
      if (next && cur) { cur.innerHTML = next.innerHTML; return; }
      if (!next && cur && cur.parentNode) { cur.parentNode.removeChild(cur); return; }
      if (next && !cur) {
        var results = $('[data-results]', section);
        if (results && results.parentNode) {
          results.parentNode.insertBefore(next.cloneNode(true), results.nextSibling);
        }
      }
    },

    /* §7.3: "The open/closed state is kept while filtering." Recorded by
       position, because the labels are merchant-renamed and translated. */
    openGroups: function (section) {
      return $$('.c-group', section).map(function (d) { return d.open; });
    },
    restoreGroups: function (section, state) {
      if (!state) return;
      $$('.c-group', section).forEach(function (d, i) {
        if (i < state.length) d.open = state[i];
      });
    }
  };

  /* ── Load more — §6.4 ─────────────────────────────────────────────────────
     The control is an <a href="?page=N">, not a button, and stays one: SEO
     depends on page 2 being a real, crawlable URL, and organic search is this
     store's primary channel. This only saves the navigation.

     `replaceState`, not `pushState` (§6.4): the shopper has not moved to a new
     view, they have more of the one they are on, and pushing would make Back
     walk them up the pages one at a time.                                   */
  var CollMore = {
    init: function () {
      var section = Coll.section();
      if (!section || !CAN_AJAX) return;
      on(section, 'click', function (e) {
        var a = e.target.closest ? e.target.closest('[data-load-more]') : null;
        if (!a || !Coll.plainClick(e)) return;
        e.preventDefault();
        CollMore.load(a, section);
      });
    },

    load: function (a, section) {
      var href = a.getAttribute('href');
      if (!href || a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true');

      fetch(Coll.renderUrl(href, section), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('page ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-results]');
          var cur = $('[data-results]', section);
          if (!next || !cur) { window.location.href = href; return; }

          /* Snapshot first: `next.children` is LIVE, and appending from it
             while iterating skips every other card. */
          var added = Array.prototype.slice.call(next.children);
          if (!added.length) { window.location.href = href; return; }
          added.forEach(function (node) { cur.appendChild(node); });

          var wrap = a.closest('[data-more-wrap]');
          var nextLink = doc.querySelector('[data-load-more]');
          if (nextLink) {
            a.setAttribute('href', nextLink.getAttribute('href'));
            a.removeAttribute('aria-busy');
          } else if (wrap && wrap.parentNode) {
            wrap.parentNode.removeChild(wrap);       /* last page */
          }

          window.history.replaceState(window.history.state, '', href);
          CollView.sync();
          Wishlist.sync(cur);

          /* §6.4: move focus to the first new card, so a keyboard user
             continues from where the page grew rather than from the top. */
          var first = added[0];
          if (first && first.focus) {
            if (!first.hasAttribute('tabindex')) first.setAttribute('tabindex', '-1');
            first.focus();
          }
        })
        .catch(function () { window.location.href = href; });
    }
  };

  /* ── Quick add — §6.1 ─────────────────────────────────────────────────────
     ONE VARIANT ONLY. §6.1 asks for a quick-view modal when a product has
     several variants; this theme has no modal component to reuse, and a
     half-built variant picker with no gallery, no inventory state and no price
     update is worse than the product page. Multi-variant cards therefore
     render an <a> to the PDP in Liquid and never reach this module.

     Posts to /cart/add.js and then opens the existing cart drawer, which
     renders sections/main-cart.liquid — so the discreet-packaging line, the
     free-shipping bar and every money string stay in Liquid and nothing here
     formats currency or invents copy.

     Every failure path navigates. A quick add that silently does nothing is
     the worst outcome on a browse page.                                     */
  var CollQuickAdd = {
    init: function () {
      on(document, 'click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-quick-add]') : null;
        if (!b) return;
        var url = b.getAttribute('data-product-url') || '/cart';
        if (!CAN_AJAX) { window.location.href = url; return; }
        /* The gate owns the screen until it is accepted. */
        if (document.documentElement.classList.contains('age-unverified')) return;
        e.preventDefault();
        CollQuickAdd.add(b, url);
      });
    },

    add: function (btn, url) {
      var id = btn.getAttribute('data-variant-id');
      if (!id) { window.location.href = url; return; }
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
        .then(function () {
          btn.removeAttribute('aria-busy');
          if (!Cart.mount()) { window.location.href = '/cart'; return; }
          /* So Esc and the close button return focus to the card, not to the
             top of the document. */
          Cart.opener = btn;
          Cart.open();
          Cart.load();
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          /* Sold out between page load and tap, or the network went. The PDP
             says which, and says it in Liquid. */
          window.location.href = url;
        });
    }
  };

  /* ── Price slider — §7.3 ──────────────────────────────────────────────────
     The two NUMBER inputs are the form; these two range inputs carry no
     `name` and can never put a parameter in the URL on their own. They write
     into the number inputs and dispatch `input`, so CollFilters' 400ms
     debounce is the single place the apply is timed.

     Delegated on the document, not bound per node: the facet form is replaced
     wholesale after every filter change.                                    */
  var CollPrice = {
    init: function () {
      on(document, 'input', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var box = t.closest('[data-price]');
        if (!box) return;
        if (t.hasAttribute('data-price-range')) CollPrice.fromSlider(box, t);
        else if (t.hasAttribute('data-price-input')) CollPrice.paint(box);
      });
      $$('[data-price]').forEach(CollPrice.paint);
    },

    nums: function (box) {
      var lo = $('[data-price-range="min"]', box);
      var hi = $('[data-price-range="max"]', box);
      var max = parseFloat(box.getAttribute('data-max'));
      return { lo: lo, hi: hi, max: isNaN(max) || max <= 0 ? 0 : max };
    },

    /* A dragged thumb must not cross the other one, or the fill inverts and
       the form ends up asking for "from 90 to 20", which returns nothing. */
    fromSlider: function (box, which) {
      var n = CollPrice.nums(box);
      if (!n.lo || !n.hi) return;
      if (parseFloat(n.lo.value) > parseFloat(n.hi.value)) {
        if (which === n.lo) n.lo.value = n.hi.value;
        else n.hi.value = n.lo.value;
      }
      var minIn = $('[data-price-input="min"]', box);
      var maxIn = $('[data-price-input="max"]', box);
      /* Written back as a BOUND, not as a literal: "0" and "the maximum" are
         the absence of a filter, and an empty string is how Shopify is told
         so. Sending them makes the URL carry a filter that filters nothing. */
      if (minIn) minIn.value = parseFloat(n.lo.value) > 0 ? n.lo.value : '';
      if (maxIn) maxIn.value = parseFloat(n.hi.value) < n.max ? n.hi.value : '';
      CollPrice.fill(box, parseFloat(n.lo.value), parseFloat(n.hi.value), n.max);
      if (minIn) minIn.dispatchEvent(new Event('input', { bubbles: true }));
    },

    /* Number input → slider. */
    paint: function (box) {
      var n = CollPrice.nums(box);
      if (!n.lo || !n.hi || !n.max) return;
      var minIn = $('[data-price-input="min"]', box);
      var maxIn = $('[data-price-input="max"]', box);
      var a = minIn && minIn.value !== '' ? parseFloat(minIn.value) : 0;
      var b = maxIn && maxIn.value !== '' ? parseFloat(maxIn.value) : n.max;
      if (isNaN(a)) a = 0;
      if (isNaN(b)) b = n.max;
      a = Math.max(0, Math.min(a, n.max));
      b = Math.max(0, Math.min(b, n.max));
      if (a > b) { var t = a; a = b; b = t; }
      n.lo.value = a;
      n.hi.value = b;
      CollPrice.fill(box, a, b, n.max);
    },

    /* The one place this file writes an inline style. base.css bans `style=""`
       in MARKUP because it defeats @media; a percentage computed from two
       live values has nowhere else to live. */
    fill: function (box, a, b, max) {
      var el = $('[data-price-fill]', box);
      if (!el || !max) return;
      el.style.insetInlineStart = (a / max * 100) + '%';
      el.style.width = ((b - a) / max * 100) + '%';
    }
  };

  /* ── "Show all N brands" — §7.3 ───────────────────────────────────────────
     The extra values are in the DOM already, so a no-JS shopper sees the full
     list (CSS reveals them under `.no-js`) and this button is not rendered to
     them. Delegated, because the facet form is replaced on every filter. */
  var CollShowAll = {
    init: function () {
      on(document, 'click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-more]') : null;
        if (!b) return;
        var group = b.closest('.c-group');
        if (!group) return;
        /* The "show all" wording is whatever Liquid rendered; it is captured
           on first use rather than reconstructed, so this file never builds a
           customer-facing string. */
        if (!b.getAttribute('data-label-more')) {
          b.setAttribute('data-label-more', b.textContent.trim());
        }
        var open = !group.classList.contains('is-expanded');
        group.classList.toggle('is-expanded', open);
        b.textContent = open
          ? (b.getAttribute('data-label-less') || b.getAttribute('data-label-more'))
          : b.getAttribute('data-label-more');
        b.setAttribute('aria-expanded', String(open));
      });
    }
  };

  /* ── Wishlist — local first. PRIVATE by default. ───────────────────────────
     ⚠️ PRIVACY-CRITICAL, per sections/wishlist.liquid. On this catalogue a
     saved list is sensitive, so it NEVER leaves the device: no fetch, no
     beacon, no query string, no cookie. The stub promised "synced when signed
     in" via an App Proxy — that is deliberately NOT implemented. See the report.

     Shape change: `tnp_wishlist` used to hold bare product ids, which is not
     enough for sections/wishlist.liquid to draw a row, and Shopify has no
     public "product by id" endpoint to recover the rest. It now holds
     {id, title, price, url}, captured from the card or the PDP at the moment
     the heart is clicked — that markup already carries all four, and reading
     them costs no request.

     Prices are stored as the RENDERED money string, never re-formatted here
     (Hard Rule 8). That means a saved price is a snapshot; the link is what
     takes the shopper to the live one.                                      */
  var Wishlist = {
    KEY: 'tnp_wishlist',

    /* Tolerates the old bare-id array so an early saver is not logged out of
       their own list. A migrated entry has no title, so it keeps the heart
       pressed but cannot draw a row — see `renderPage`. */
    read: function () {
      var raw;
      try { raw = JSON.parse(localStorage.getItem(Wishlist.KEY) || '[]'); }
      catch (e) { return []; }
      if (!raw || typeof raw.length !== 'number') return [];
      var out = [];
      for (var i = 0; i < raw.length; i++) {
        var it = raw[i];
        if (it && typeof it === 'object') {
          if (it.id === undefined || it.id === null) continue;
          out.push({
            id: String(it.id),
            title: String(it.title || ''),
            price: String(it.price || ''),
            url: Wishlist.safeUrl(it.url)
          });
        } else if (it !== null && it !== undefined && String(it).length) {
          out.push({ id: String(it), title: '', price: '', url: '' });
        }
      }
      return out;
    },

    write: function (items) {
      try { localStorage.setItem(Wishlist.KEY, JSON.stringify(items)); }
      catch (e) { /* private window — session only, and that is acceptable */ }
    },

    /* Storage is attacker-reachable in a shared browser, so a stored href is
       treated as untrusted: same-origin paths only, never javascript: or an
       off-site URL wearing a product's name. */
    safeUrl: function (url) {
      var s = String(url || '');
      return s.charAt(0) === '/' && s.charAt(1) !== '/' ? s : '';
    },

    indexOf: function (items, id) {
      for (var i = 0; i < items.length; i++) { if (items[i].id === String(id)) return i; }
      return -1;
    },

    /* Everything the row needs is already on screen; this just reads it. The
       selectors are ordered card → PDP → the wishlist page's own row. */
    capture: function (btn) {
      /* ⚠️ `.c-card` HAS TO BE IN THIS LIST. The collection page draws its own
         card (COLLECTION-PAGE-SPEC §6.1) and does not use `.product-card`.
         Without it `scope` falls through to `document`, and every save from a
         collection page stored the title, price and URL of whatever product
         happened to be first in the DOM.

         ⚠️ AND SO DO `.bs-card` AND `.cl-card`, FOR EXACTLY THAT REASON. The
         homepage's bestsellers and clearance rows shipped with no save toggle
         at all, and the card convergence left it that way on purpose: the two
         were absent from this list, so a heart added there fell through to
         `document`. Measured on the live homepage at 1280px, 4 Oct 2026, by
         putting the heart in the DOM and letting the DEPLOYED build of this
         file handle the click: saving the Sensation Kit card stored

           {"id":"7805009461335","title":"","price":"$11.99","url":"/"}

         Worse than the collection-page case above, not better. The id is the
         only true field. The title is EMPTY, because a homepage has no
         `.c-card__title`, no `.product-card__title a` and no `.pdp__title`
         for the chain to land on; `$11.99` is just the first `.price__current`
         in the document; and `/` is the canonical fallback at the bottom of
         this function firing on a page that is not a PDP. An entry like that
         cannot even be drawn — `renderPage` filters out titleless items — so
         the save silently does nothing and the heart stays lit.

         The toggle exists on all four cards now, so both classes are here,
         and the field lookups below carry their selectors too:

           - `titleEl`: `.bs-card__title` / `.cl-card__title` are an <h3>/<h4>
             WRAPPING the anchor, so neither `.c-card__title` (itself the
             anchor) nor `.product-card__title a` matches one. The heading's
             textContent is the title.
           - `priceEl`: already resolved — both render snippets/card-price,
             which prints `.price__current`, the third fallback.
           - `linkEl`: the href is on the heading's CHILD anchor, so it needs
             `.bs-card__title a` / `.cl-card__title a`, not the heading. Miss
             it and `url` falls back to the PDP canonical branch below, which
             on the homepage is the homepage. */
      var scope = btn.closest('[data-wishlist-row]') ||
                  btn.closest('.c-card') ||
                  btn.closest('.product-card') ||
                  btn.closest('.bs-card') ||
                  btn.closest('.cl-card') ||
                  btn.closest('.pdp__buy') || document;
      var titleEl = $('[data-field="title"]', scope) ||
                    $('.c-card__title', scope) ||
                    $('.product-card__title a', scope) ||
                    $('.bs-card__title', scope) ||
                    $('.cl-card__title', scope) ||
                    $('.pdp__title', scope);
      var priceEl = $('[data-field="price"]', scope) ||
                    $('.c-card__info .c-card__price b', scope) ||
                    $('.price__current', scope);
      var linkEl = $('[data-field="url"]', scope) ||
                   $('.c-card__title', scope) ||
                   $('.product-card__title a', scope) ||
                   $('.bs-card__title a', scope) ||
                   $('.cl-card__title a', scope);

      var url = linkEl ? linkEl.getAttribute('href') : '';
      if (!url) {
        /* PDP: the canonical is the product, without whichever variant happens
           to be selected. Path only — the stored list must not carry a host. */
        var canonical = $('link[rel="canonical"]');
        try { url = new URL(canonical ? canonical.href : window.location.href).pathname; }
        catch (e) { url = window.location.pathname; }
      }

      return {
        id: String(btn.getAttribute('data-product-id') || ''),
        title: titleEl ? titleEl.textContent.trim() : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        url: Wishlist.safeUrl(url)
      };
    },

    toggle: function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      var items = Wishlist.read();
      var at = Wishlist.indexOf(items, id);
      if (at > -1) items.splice(at, 1);
      else items.push(Wishlist.capture(btn));
      Wishlist.write(items);
      Wishlist.sync(document);
      Wishlist.renderPage();
    },

    sync: function (root) {
      var items = Wishlist.read();
      $$('[data-wishlist-toggle][data-product-id]', root).forEach(function (b) {
        b.setAttribute('aria-pressed',
          String(Wishlist.indexOf(items, b.getAttribute('data-product-id')) > -1));
      });
      Wishlist.count(items.length);
    },

    /* The header badge. Liquid cannot render this — the list is localStorage
       and the server has never seen it — so the markup ships hidden and this
       is the only thing that reveals it. Hidden at zero rather than showing a
       0, which matches the cart badge and keeps a screen reader from
       announcing an empty list every page. */
    count: function (n) {
      var badge = $('[data-wishlist-count]');
      var text = $('[data-wishlist-count-text]');
      if (badge) {
        badge.textContent = n > 99 ? '99+' : String(n);
        badge.hidden = n === 0;
      }
      if (text) text.textContent = n ? n + ' saved item' + (n === 1 ? '' : 's') : '';
    },

    /* Clones sections/wishlist.liquid's own <template>. The section states the
       failure direction: it un-hides the grid only once there is something to
       show, so a JS fault looks empty rather than showing a stale list. */
    renderPage: function () {
      var grid = $('[data-wishlist-grid]');
      var tpl = $('[data-wishlist-item-template]');
      if (!grid || !tpl || !tpl.content) return;
      var empty = $('[data-wishlist-empty]');

      /* A migrated bare id has no title or link, so there is nothing truthful
         to draw. It stays in storage — the heart on its PDP still reads as
         saved — but it is not invented into a row here. */
      var items = Wishlist.read().filter(function (it) { return it.title && it.url; });

      grid.textContent = '';
      items.forEach(function (it) {
        var row = tpl.content.firstElementChild;
        if (!row) return;
        var node = row.cloneNode(true);
        var title = $('[data-field="title"]', node);
        var price = $('[data-field="price"]', node);
        var link = $('[data-field="url"]', node);
        var btn = $('[data-wishlist-toggle]', node);
        if (title) title.textContent = it.title;
        if (price) price.textContent = it.price;
        if (link) link.setAttribute('href', it.url);
        if (btn) {
          btn.setAttribute('data-product-id', it.id);
          btn.setAttribute('aria-pressed', 'true');
        }
        grid.appendChild(node);
      });

      grid.hidden = items.length === 0;
      if (empty) empty.hidden = items.length > 0;
    },

    init: function () {
      /* Delegated so hearts on filter-rendered cards and on cloned wishlist
         rows work without any re-binding. */
      on(document, 'click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
        if (btn) Wishlist.toggle(btn);
      });
      Wishlist.sync(document);
      Wishlist.renderPage();
    }
  };

  /* ── Mobile sticky add-to-cart ─────────────────────────────────────────────
     `[data-sticky-add]` is a <button type="button"> sitting OUTSIDE the product
     form, so it does nothing at all without JS. This forwards it to the real
     form, keeping Shopify's own /cart/add as the single add path. The no-JS
     gap is a markup problem, not a JS one — it is in the report.            */
  /* [data-sticky-add] needs NO JavaScript. It is `type="submit"
     form="pdp-form"` in sections/main-product.liquid, so the browser submits
     the buy form natively — which also means it works with JS off.

     A StickyBuy module used to sit here calling form.requestSubmit() on click.
     With the native submit that is TWO /cart/add posts from one tap: the
     shopper gets the item twice. Do not reintroduce it. If the markup ever
     goes back to type="button", fix the markup, not this file. */

  /* ── Server-rendered form errors ───────────────────────────────────────────
     Every customer form in this theme is a full-page POST, so the error block
     is already in the document at parse time. `role="alert"` only fires on
     insertion or mutation, which means a screen-reader user is never told the
     submit failed — they are simply returned to a page that looks the same.

     Moving focus to the container does both jobs: it announces the error and it
     puts the keyboard user AT the problem instead of at the top of the
     document. The containers carry `tabindex="-1"` in the markup, so this is
     focusable without ever entering the tab order.                          */
  var FormErrors = {
    init: function () {
      /* An empty container is not an error — only a filled one counts. */
      var err = $$('[data-form-error]').filter(function (el) {
        return el.textContent.trim().length > 0;
      })[0];
      if (!err) return;

      /* Never over the age gate: the gate owns the screen and the keyboard
         until it is accepted. Wait for it rather than fight it. */
      if (document.documentElement.classList.contains('age-unverified')) {
        document.addEventListener('tnp:age-accepted', function () { FormErrors.focus(err); }, { once: true });
        return;
      }
      FormErrors.focus(err);
    },
    focus: function (err) {
      if (!err.hasAttribute('tabindex')) err.setAttribute('tabindex', '-1');
      /* Deferred a tick, so the browser's own scroll/focus restoration on a
         reload does not immediately undo it. */
      setTimeout(function () {
        err.focus();
        if (err.scrollIntoView) err.scrollIntoView({ block: 'center' });
      }, 0);
    }
  };

  /* ── Best sellers — tab panels + scroller arrows ──────────────────────────
     Enhancement only, in two parts.

     1. TABS. The markup already ships the WAI-ARIA tabs pattern in full — real
        <button role="tab"> with aria-controls, aria-selected and a roving
        tabindex, and <div role="tabpanel"> labelled back. What is missing
        without JS is the panel swap and the arrow keys, and that is all this
        adds. Panels are shown and hidden by CSS keyed off `data-current`,
        under `html:not(.no-js)`, so with JS OFF every panel stays visible and
        the five rows simply stack — nothing is trapped behind an inert button.
        `data-current` is the same one-attribute state the gallery uses.

     2. ARROWS. `.bs__panel` is a native scroll container: it swipes, it snaps,
        it keyboard-scrolls, all without JS. These buttons only call scrollBy
        on it. No transform, no autoplay, no scroll hijacking — same rule the
        gallery states. base.css hides them under html.no-js because an arrow
        that cannot scroll is worse than no arrow.

     ⚠️ GEOMETRY IS READ FROM THE CURRENT PANEL ONLY. A non-current panel is
     display:none, where clientWidth and scrollWidth are both 0; measuring one
     would disable both arrows and look like a broken carousel. For the same
     reason the read after a tab switch is deferred a turn, and the read after
     a resize is on a setTimeout rather than a frame callback — a rect taken
     immediately after a resize still describes the previous width.          */
  var BestTabs = {
    /* One source for the scroll behaviour. tokens.css already zeroes the
       durations under prefers-reduced-motion, but a smooth `scrollBy` is a
       scroll animation, not a CSS transition, so it has to be asked here. */
    motion: function () {
      return (window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches)
        ? 'auto' : 'smooth';
    },

    /* An arrow at the end of its travel is disabled, not hidden — including
       the case that matters most here: a collection shorter than `count`
       leaves scrollWidth === clientWidth, so both arrows go dead and the short
       row sits still instead of jittering. */
    sync: function (root) {
      BestTabs.fade(root);
      var prev = $('[data-bs-prev]', root);
      var next = $('[data-bs-next]', root);
      if (!prev && !next) return;
      var panel = $('[data-bs-panel][data-current]', root);
      if (!panel) return;
      var max = panel.scrollWidth - panel.clientWidth;
      var at = Math.abs(panel.scrollLeft);
      /* 2px of slack: sub-pixel layout means scrollLeft rarely lands exactly
         on 0 or exactly on the maximum. */
      if (prev) prev.disabled = at <= 2;
      if (next) next.disabled = at >= max - 2;
    },

    /* The tab row's affordance, measured the same way the arrows above are:
       read the scroller, write state, let CSS draw. `data-fade` carries the
       LOGICAL edges that still have content behind them — base.css maps start
       to the left edge, or the right one under dir="rtl".

       Written on every sync, so a resize, a font swap or a tab change all
       re-measure rather than trusting a breakpoint. The 2px of slack is the
       same sub-pixel allowance the arrows use. */
    fade: function (root) {
      var list = $('[data-bs-tablist]', root);
      if (!list) return;
      var max = list.scrollWidth - list.clientWidth;
      var at = Math.abs(list.scrollLeft);
      var edges = [];
      if (max > 2) {
        if (at > 2) edges.push('start');
        if (at < max - 2) edges.push('end');
      }
      list.setAttribute('data-fade', edges.join(' '));
    },

    /* Bring a tab fully into the visible part of the row.

       scrollLeft arithmetic and NOT scrollIntoView, for the reason written on
       Gallery.pick: scrollIntoView walks every scrollable ancestor and would
       scroll the PAGE to the section as well — on arrow-key navigation that
       means the document jumping under a keyboard user on every press.

       The clearance is scroll-padding-inline, which base.css sets to one fade
       width rather than one gutter: a tab parked under the fade gradient is
       half-transparent, and the tab the keyboard just landed on has to be
       legible. paddingLeft/Right is the fallback for a browser that reports
       scroll-padding as `auto`. Physical edges on purpose — the two clamps
       below are symmetric, so this is correct in RTL without a second path. */
    reveal: function (root, tab) {
      var list = $('[data-bs-tablist]', root);
      if (!list || !tab) return;
      if (list.scrollWidth - list.clientWidth <= 2) return;
      var cs = window.getComputedStyle(list);
      var padS = parseFloat(cs.scrollPaddingLeft) || parseFloat(cs.paddingLeft) || 0;
      var padE = parseFloat(cs.scrollPaddingRight) || parseFloat(cs.paddingRight) || 0;
      var lb = list.getBoundingClientRect();
      var tb = tab.getBoundingClientRect();
      var by = 0;
      if (tb.left - padS < lb.left) by = tb.left - padS - lb.left;
      else if (tb.right + padE > lb.right) by = tb.right + padE - lb.right;
      if (!by) return;
      if (list.scrollBy) list.scrollBy({ left: by, behavior: BestTabs.motion() });
      else list.scrollLeft += by;
    },

    init: function () {
      $$('[data-bs-tabs]').forEach(function (root) { BestTabs.wire(root); });
    },

    /* ── ?dept= DEEP LINK ───────────────────────────────────────────────
       OPT-IN, and off unless the markup asks for it: `data-bs-param` on the
       wrapper names the query parameter and `data-bs-key` on each tab gives
       its value. The bestsellers row carries neither, so nothing about it
       changes — it has no URL of its own and writing ?tab=… from a homepage
       carousel would be noise in the address bar.

       replaceState, never pushState: ALL-CATEGORIES-SPEC §5 is explicit that
       changing tab must not add a history entry, because the Back button on
       this page belongs to the phone search overlay. */
    param: function (root, tabs, i, initial) {
      var name = root.getAttribute('data-bs-param');
      if (!name || initial) return;
      if (!window.history || !window.history.replaceState || !window.URL) return;
      var key = tabs[i] && tabs[i].getAttribute('data-bs-key');
      if (!key) return;
      try {
        var u = new window.URL(window.location.href);
        if (u.searchParams.get(name) === key) return;
        u.searchParams.set(name, key);
        window.history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) { /* an exotic URL is not worth failing the tab over */ }
    },

    wire: function (root) {
      var tabs = $$('[data-bs-tab]', root);
      var panels = $$('[data-bs-panel]', root);
      /* Liquid skips the same blocks in both loops, so a mismatch means the
         markup changed underneath this module. Stand down rather than pair a
         tab with the wrong row. */
      if (!tabs.length || tabs.length !== panels.length) return;

      /* No RTL locale ships today (en, es). Reading direction anyway costs one
         property and keeps the arrow keys and the arrows themselves correct if
         one is ever added — in RTL, "next" travels left. */
      var rtl = document.documentElement.getAttribute('dir') === 'rtl' ||
                (root.closest && root.closest('[dir="rtl"]') !== null);

      function select(i, moveFocus, initial) {
        BestTabs.param(root, tabs, i, initial);
        tabs.forEach(function (t, n) {
          var isOn = n === i;
          t.setAttribute('aria-selected', isOn ? 'true' : 'false');
          t.tabIndex = isOn ? 0 : -1;
          if (isOn) t.setAttribute('data-current', '');
          else t.removeAttribute('data-current');
        });
        panels.forEach(function (p, n) {
          if (n === i) p.setAttribute('data-current', '');
          else p.removeAttribute('data-current');
        });
        if (moveFocus && tabs[i]) tabs[i].focus();
        /* The selected tab must be on screen however it was selected — a
           click near the edge, an arrow key, Home, End. Before the sync, so
           the fade is measured after the row has been told where to go. */
        BestTabs.reveal(root, tabs[i]);
        setTimeout(function () { BestTabs.sync(root); }, 0);
      }

      tabs.forEach(function (t, i) {
        on(t, 'click', function () { select(i); });
        /* Roving tabindex means Tab into the row lands on the SELECTED tab,
           which may be scrolled off after a resize — and a browser that
           focuses without scrolling leaves it invisible. Cheap insurance;
           reveal() is a no-op when the tab is already fully in view. */
        on(t, 'focus', function () { BestTabs.reveal(root, t); });
        on(t, 'keydown', function (e) {
          var fwd = rtl ? 'ArrowLeft' : 'ArrowRight';
          var back = rtl ? 'ArrowRight' : 'ArrowLeft';
          var to = -1;
          if (e.key === fwd) to = (i + 1) % tabs.length;
          else if (e.key === back) to = (i + tabs.length - 1) % tabs.length;
          else if (e.key === 'Home') to = 0;
          else if (e.key === 'End') to = tabs.length - 1;
          if (to < 0) return;
          e.preventDefault();
          select(to, true);
        });
      });

      /* The deep link, read once on wire. `initial` is true so the tab that
         the URL already names is not written back to the URL — a plain
         /collections visit must not gain a ?dept= it did not arrive with. */
      var pname = root.getAttribute('data-bs-param');
      if (pname && window.URL) {
        try {
          var want = new window.URL(window.location.href).searchParams.get(pname);
          if (want) {
            for (var w = 0; w < tabs.length; w++) {
              if (tabs[w].getAttribute('data-bs-key') === want) { select(w, false, true); break; }
            }
          }
        } catch (e) { /* no deep link, first tab stands */ }
      }

      /* Scroll by whole cards, never by a guessed fraction of the viewport:
         the pitch is measured from two real slides, so a half card is never
         left hanging at the edge. */
      function paged(dir) {
        var panel = $('[data-bs-panel][data-current]', root);
        if (!panel) return;
        var slides = $$('[data-bs-slide]', panel);
        if (!slides.length) return;
        var pitch = slides.length > 1
          ? Math.abs(slides[1].getBoundingClientRect().left -
                     slides[0].getBoundingClientRect().left)
          : slides[0].getBoundingClientRect().width;
        if (!pitch) return;
        var by = (rtl ? -dir : dir) *
                 Math.max(1, Math.floor(panel.clientWidth / pitch)) * pitch;
        if (panel.scrollBy) panel.scrollBy({ left: by, behavior: BestTabs.motion() });
        else panel.scrollLeft += by;
      }

      on($('[data-bs-prev]', root), 'click', function () { paged(-1); });
      on($('[data-bs-next]', root), 'click', function () { paged(1); });

      /* A snap scroll fires `scroll` dozens of times; unthrottled, each one
         would measure the panel. Same guard the gallery uses. */
      var queued = false;
      panels.forEach(function (p) {
        on(p, 'scroll', function () {
          if (queued) return;
          queued = true;
          raf(function () { queued = false; BestTabs.sync(root); });
        });
      });

      /* Swiping the tab row itself only moves the fade, so it calls fade()
         and not the whole sync — same raf guard, its own flag. */
      var tabQueued = false;
      on($('[data-bs-tablist]', root), 'scroll', function () {
        if (tabQueued) return;
        tabQueued = true;
        raf(function () { tabQueued = false; BestTabs.fade(root); });
      });

      var resizeTimer = null;
      on(window, 'resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { BestTabs.sync(root); }, 150);
      });

      setTimeout(function () { BestTabs.sync(root); }, 0);
    }
  };

  /* ── Finder — /collections, ALL-CATEGORIES-SPEC "Option C" ────────────────
     Still no second predictive implementation and no second fetch: PRODUCTS
     are the Search module above, the tabs are BestTabs (same data-bs-*
     contract as the bestsellers row, plus the optional ?dept= deep link),
     and the overlay's focus trap is the shared trapTab.

     What this module owns:

       1. CATEGORIES, IN THE BROWSER. Spec §8.3. The page carries every
          menu-linked subcategory as JSON and this filters it on the
          keystroke — no debounce, no request. It is not an optimisation, it
          is the only way to meet §0 and §3.1: measured against the live
          storefront, Shopify's predictive index hands back `cockrings`
          beside `cock-rings` and `anal` beside `anal-toys` (the duplicates
          §0 says must never appear here, because it knows nothing about the
          menu), and it matches word PREFIXES only, so §3.1's "match anywhere
          in the title" is unreachable through it. Prices still come from the
          server for the reason written at psearch_url in the section.
       2. THE MERGE. `Search.decorators` runs this after each product
          response, so one panel carries both groups and one arrow-key cursor
          walks them. Registered only when there is an index to search.
       3. CLEAR. The ✕ inside the search pill. It empties the field AND
          dispatches `input`, because that event is what tells Search to close
          the panel — a `type="reset"` button would blank the box and leave a
          stale dropdown hanging under it.
       4. OVERLAY. Below 750 the field opens a full-screen search (§3.1) and
          the BACK BUTTON closes it. Same dialog contract as CollSheet: role
          and aria-modal set on open, Esc closes, `html.nav-open` locks the
          background, focus goes into the overlay's own input and returns to
          the field. Before two characters it shows Popular and Recent
          searches instead of suggestions.
       5. MORE. The phone shows the first `mobile_initial_count` tiles per
          category and this reveals the rest. The cap itself is CSS —
          responsive.css shows every tile and hides this button from 750 up —
          so there is nothing to undo here when the window is wide.
       6. Two small jobs the spec names and nothing else can do: the
          placeholder swap at 750 (§3) and scrolling the panel title clear of
          the stuck tab row on a phone (§5).                                */
  var Finder = {
    overlay: null, root: null, input: null, hero: null,
    index: [], fallback: [], strings: {},
    returning: false,

    RECENT_KEY: 'tnp:recent',
    RECENT_CAP: 5,

    isOpen: function () {
      return !!(Finder.overlay && Finder.overlay.hasAttribute('data-open'));
    },

    /* `new Event` is not available everywhere this theme still runs, and the
       clear button must work with or without CAN_AJAX — it is the only way
       back out of a typed query on a phone. */
    fire: function (el, name) {
      var ev;
      if (typeof window.Event === 'function') {
        ev = new Event(name, { bubbles: true });
      } else {
        ev = document.createEvent('Event');
        ev.initEvent(name, true, false);
      }
      el.dispatchEvent(ev);
    },

    /* ── Text helpers ─────────────────────────────────────────────────────
       EVERYTHING that reaches innerHTML goes through `esc` first. The titles
       come out of a JSON blob the merchant's own catalogue filled, and the
       term comes out of the shopper's keyboard. */
    esc: function (v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },

    /* Spec §3.1: "hyphens and spaces treated the same" — `g spot` has to find
       `G-Spot`, and on this store also `G Spot`, which is a third spelling of
       the same category. Collapsed to single spaces so `cock  rings` matches
       too. */
    norm: function (v) {
      return String(v || '').toLowerCase().replace(/[-\s]+/g, ' ').trim();
    },

    /* The matched run in 600 weight (§3.1). The offset is found in the
       NORMALISED string and applied to the ORIGINAL, which is only safe
       because `norm` never changes the character count of a run it keeps —
       it maps one separator to one space. */
    mark: function (text, term) {
      var n = Finder.norm(text);
      var q = Finder.norm(term);
      var at = q ? n.indexOf(q) : -1;
      if (at < 0) return Finder.esc(text);
      return Finder.esc(text.slice(0, at)) +
             '<b>' + Finder.esc(text.slice(at, at + q.length)) + '</b>' +
             Finder.esc(text.slice(at + q.length));
    },

    /* ── The category index (spec §8.3) ───────────────────────────────────
       Substring, case-insensitive, starts-with first then A–Z, max 6. */
    match: function (term) {
      var q = Finder.norm(term);
      if (q.length < 2) return [];
      var hits = Finder.index.filter(function (c) {
        return Finder.norm(c.t).indexOf(q) > -1;
      });
      hits.sort(function (a, b) {
        var sa = Finder.norm(a.t).indexOf(q) === 0 ? 0 : 1;
        var sb = Finder.norm(b.t).indexOf(q) === 0 ? 0 : 1;
        if (sa !== sb) return sa - sb;
        return a.t.localeCompare(b.t);
      });
      return hits.slice(0, 6);
    },

    /* One category column, in the SAME markup sections/predictive-search
       .liquid renders for a server-side category group — same classes, same
       roles, same `data-psearch-item` — so the Search module's arrow-key
       cursor walks these rows without knowing where they came from, and
       base.css needs not one new selector. */
    catsHTML: function (hits, term) {
      var S = Finder.strings;
      var rows = hits.map(function (c, i) {
        var art = c.i
          ? '<span class="psearch__media media media--square">' +
              '<img src="' + Finder.esc(c.i) + '" alt="" width="40" height="40" loading="lazy">' +
            '</span>'
          : '<span class="psearch__glyph" data-tint="' + ((i % 6) + 1) + '" aria-hidden="true">' +
              Finder.esc(c.t.charAt(0).toUpperCase()) +
            '</span>';
        var meta = c.d
          ? '<span class="psearch__meta">' +
              Finder.esc(S.inDept || '').replace('%DEPT%', Finder.esc(c.d)) +
            '</span>'
          : '';
        return '<li class="psearch__item psearch__item--cat" role="option"' +
                 ' id="finder-cat-' + i + '" aria-selected="false" data-psearch-item>' +
                 '<a class="psearch__link" href="' + Finder.esc(c.u) + '" tabindex="-1">' +
                   art +
                   '<span class="psearch__body">' +
                     '<span class="psearch__title psearch__title--cat">' +
                       Finder.mark(c.t, term) +
                     '</span>' + meta +
                   '</span>' +
                   '<span class="psearch__go" aria-hidden="true">&rarr;</span>' +
                 '</a>' +
               '</li>';
      }).join('');
      var label = Finder.esc(S.categories || '');
      return '<div class="psearch__col">' +
               '<p class="psearch__group" aria-hidden="true">' + label + '</p>' +
               '<ul class="psearch__list" role="group" aria-label="' + label + '">' +
                 rows +
               '</ul>' +
             '</div>';
    },

    seeAllHTML: function (term) {
      var S = Finder.strings;
      var href = (S.searchUrl || '/search') + '?q=' + encodeURIComponent(term);
      return '<a class="psearch__all" href="' + Finder.esc(href) + '">' +
               Finder.esc(S.seeAll || '').replace('%TERM%', Finder.esc(term)) +
             '</a>';
    },

    /* ── Paint 1 of 2: INSTANT, no network ────────────────────────────────
       Runs on the keystroke. The whole point of the embedded index is that a
       category suggestion costs nothing, so it must not wait behind the
       product request's debounce. */
    paint: function (input, mount, term) {
      var hits = Finder.match(term);
      if (!hits.length) return;               /* leave the server to answer */
      mount.innerHTML = '<div class="psearch__cols" role="listbox" aria-label="' +
                          Finder.esc(Finder.strings.categories || '') + '">' +
                          Finder.catsHTML(hits, term) +
                        '</div>' + Finder.seeAllHTML(term);
      mount.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      Search.bindListbox(input, mount);
      Search.index = -1;
      Search.cursor(input, $$('[data-psearch-item]', mount));
      Finder.dim(true);
    },

    /* ── Paint 2 of 2: MERGE, after the products land ─────────────────────
       Registered on Search.decorators, so it runs on every response for
       every Finder box and on nothing else. Four shapes come back:

         products + categories → prepend the column, split the grid
         products only         → leave it exactly as the server drew it
         nothing + categories  → throw the empty state away, keep the column
         nothing at all        → swap in §8.1's `fallback` chips            */
    merge: function (input, mount, term) {
      if (!input.hasAttribute('data-finder-input') &&
          !input.hasAttribute('data-finder-overlay-input')) return;

      var hits = Finder.match(term);
      var cols = $('.psearch__cols', mount);
      var empty = $('.psearch__empty', mount);

      if (cols && hits.length) {
        cols.insertAdjacentHTML('afterbegin', Finder.catsHTML(hits, term));
        cols.classList.add('psearch__cols--split');
        return;
      }
      if (cols) return;

      if (hits.length) {
        mount.innerHTML = '<div class="psearch__cols" role="listbox" aria-label="' +
                            Finder.esc(Finder.strings.categories || '') + '">' +
                            Finder.catsHTML(hits, term) +
                          '</div>' + Finder.seeAllHTML(term);
        /* A NEW listbox element, so the combobox's aria-controls has to follow
           it — the one this replaced is gone from the document. */
        Search.bindListbox(input, mount);
        return;
      }

      /* No results at all. sections/predictive-search.liquid already drew the
         message and a row of chips from the `collection-chips` menu; §3.1
         wants THIS page's own five. It cannot read them — it is fetched
         standalone — so the swap happens here. */
      if (empty && Finder.fallback.length) {
        var row = $('.psearch__suggests', empty);
        var html = Finder.fallback.map(function (f) {
          return '<a class="psearch__suggest" href="' + Finder.esc(f.u) + '">' +
                   Finder.esc(f.t) + '</a>';
        }).join('');
        if (row) { row.innerHTML = html; return; }
        var note = $('.psearch__empty-note', empty);
        var block = '<p class="psearch__empty-note">' +
                      Finder.esc(Finder.strings.tryInstead || '') + '</p>' +
                    '<div class="psearch__suggests">' + html + '</div>';
        if (!note) $('.psearch__empty-title', empty).insertAdjacentHTML('afterend', block);
      }
    },

    /* §3.1: the chips and the featured row drop to 35% while a panel is
       open. Written on the section, never on <body>. */
    dim: function (on_) {
      if (!Finder.root) return;
      if (on_) Finder.root.setAttribute('data-suggesting', '');
      else Finder.root.removeAttribute('data-suggesting');
    },

    /* ── Recent searches (§3.1) ───────────────────────────────────────────
       Its own key, NOT the `tnp_recent` the recently-viewed row uses: that
       one holds product ids and is capped at 12. Every access is wrapped —
       localStorage throws outright in a locked-down browser, and a search
       box must not be what breaks there. */
    recentRead: function () {
      try {
        var v = JSON.parse(window.localStorage.getItem(Finder.RECENT_KEY) || '[]');
        return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
      } catch (e) { return []; }
    },
    recentWrite: function (list) {
      try {
        window.localStorage.setItem(Finder.RECENT_KEY,
          JSON.stringify(list.slice(0, Finder.RECENT_CAP)));
      } catch (e) { /* nothing depends on it */ }
    },
    recentAdd: function (term) {
      term = String(term || '').trim();
      if (!term) return;
      var list = Finder.recentRead().filter(function (v) { return v !== term; });
      list.unshift(term);
      Finder.recentWrite(list);
    },
    recentPaint: function () {
      var host = $('[data-finder-recent]');
      var sec = $('[data-finder-recent-sec]');
      if (!host || !sec) return;
      var list = Finder.recentRead();
      if (!list.length) { sec.hidden = true; host.innerHTML = ''; return; }
      var rm = host.getAttribute('data-remove-label') || '';
      host.innerHTML = list.map(function (v) {
        var e = Finder.esc(v);
        var href = (Finder.strings.searchUrl || '/search') + '?q=' + encodeURIComponent(v);
        return '<li><a href="' + Finder.esc(href) + '">' + e + '</a>' +
               '<button type="button" data-finder-recent-rm="' + e + '" ' +
               'aria-label="' + Finder.esc(rm).replace('%TERM%', e) + '">&times;</button></li>';
      }).join('');
      sec.hidden = false;
    },

    /* The overlay shows Popular + Recent until there are two characters, and
       the suggestion mount after that. Never both. */
    idle: function (show) {
      var box = $('[data-finder-idle]');
      var mount = $('[data-psearch-mount]', Finder.overlay);
      if (box) box.hidden = !show;
      if (mount && show) { mount.hidden = true; }
      if (show) Finder.recentPaint();
    },

    /* §3: the long prompt from 750 up, the short one below. A placeholder is
       an attribute, so this is the only place it can change. */
    placeholder: function () {
      var el = $('[data-finder-ph-wide]');
      if (!el) return;
      var wide = el.getAttribute('data-finder-ph-wide');
      var narrow = el.getAttribute('data-finder-ph-narrow');
      if (!narrow) { narrow = el.placeholder; el.setAttribute('data-finder-ph-narrow', narrow); }
      el.placeholder = window.innerWidth >= 750 ? wide : narrow;
    },

    /* §5: "On mobile, if the tab row is stuck, scroll so the panel title sits
       just under it." Only when it IS stuck — correcting the scroll of a row
       that is still in the flow would yank the page for no reason. */
    settle: function () {
      var row = $('.fnd__tabs');
      if (!row || window.innerWidth >= 750) return;
      var offset = 0;
      try {
        var cs = window.getComputedStyle(row);
        offset = parseFloat(cs.insetBlockStart || cs.top) || 0;
      } catch (e) { return; }
      if (row.getBoundingClientRect().top > offset + 1) return;
      var panel = $('.fnd__panel[data-current]');
      if (!panel) return;
      var y = (window.pageYOffset || document.documentElement.scrollTop) +
              panel.getBoundingClientRect().top - (offset + row.offsetHeight + 8);
      var how = (window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches)
        ? 'auto' : 'smooth';
      if (window.scrollTo) {
        try { window.scrollTo({ top: y, behavior: how }); }
        catch (e) { window.scrollTo(0, y); }
      }
    },

    init: function () {
      Finder.root = $('[data-finder]');
      Finder.overlay = $('[data-finder-overlay]');
      Finder.hero = $('[data-finder-input]');
      if (Finder.overlay) Finder.input = $('[data-psearch-input]', Finder.overlay);
      if (!Finder.root && !Finder.overlay) return;

      if (Finder.root) {
        Finder.strings = {
          categories: Finder.root.getAttribute('data-s-categories'),
          seeAll: Finder.root.getAttribute('data-s-see-all'),
          noResults: Finder.root.getAttribute('data-s-no-results'),
          tryInstead: Finder.root.getAttribute('data-s-try'),
          inDept: Finder.root.getAttribute('data-s-in'),
          searchUrl: Finder.root.getAttribute('data-search-url') || '/search'
        };
      }

      /* The two JSON blobs. A malformed one must cost the page nothing — the
         server's own suggestions still work without either. */
      var idx = $('[data-finder-index]');
      if (idx) { try { Finder.index = JSON.parse(idx.textContent) || []; } catch (e) { Finder.index = []; } }
      var fb = $('[data-finder-fallback]');
      if (fb) { try { Finder.fallback = JSON.parse(fb.textContent) || []; } catch (e) { Finder.fallback = []; } }

      Finder.placeholder();
      on(window, 'resize', Finder.placeholder);

      if (Finder.index.length) Search.decorators.push(Finder.merge);

      /* Instant categories, on the keystroke. Bound AFTER Search.init has
         bound its own handler to the same inputs, so Search has already
         cleared the panel for a query under two characters by the time this
         runs. */
      $$('[data-finder-input], [data-finder-overlay-input]').forEach(function (el) {
        var mount = document.getElementById(el.getAttribute('aria-controls') || '');
        on(el, 'input', function () {
          var q = el.value.trim();
          var inOverlay = el.hasAttribute('data-finder-overlay-input');
          if (q.length < 2) {
            Finder.dim(false);
            if (inOverlay) Finder.idle(true);
            return;
          }
          if (inOverlay) Finder.idle(false);
          if (mount && Finder.index.length) Finder.paint(el, mount, q);
        });
        /* A query the shopper actually submitted is what "recent" means —
           not every keystroke on the way to it. No preventDefault: the form
           is still a real GET to /search. */
        if (el.form) on(el.form, 'submit', function () { Finder.recentAdd(el.value); });
      });

      on(document, 'click', function (e) {
        if (!e.target.closest) return;

        var clear = e.target.closest('[data-finder-clear]');
        if (clear) {
          var field = $('input[data-psearch-input]', clear.parentNode);
          if (field) { field.value = ''; Finder.fire(field, 'input'); field.focus(); }
          Finder.dim(false);
          return;
        }

        var rm = e.target.closest('[data-finder-recent-rm]');
        if (rm) {
          var gone = rm.getAttribute('data-finder-recent-rm');
          Finder.recentWrite(Finder.recentRead().filter(function (v) { return v !== gone; }));
          Finder.recentPaint();
          return;
        }

        var more = e.target.closest('[data-finder-more]');
        if (more) {
          var panel = more.closest('[data-bs-panel]');
          if (!panel) return;
          var open = more.getAttribute('aria-expanded') === 'true';
          more.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) panel.removeAttribute('data-expanded');
          else panel.setAttribute('data-expanded', '');
          return;
        }

        if (e.target.closest('[data-finder-close]')) { Finder.close(); return; }

        if (e.target.closest('.fnd__tab')) {
          /* After BestTabs has swapped the panel, not before it. */
          setTimeout(Finder.settle, 0);
          return;
        }

        /* Clicking anywhere that is not a finder search box takes the dim
           off with the panel Search itself is closing. */
        if (!e.target.closest('.fnd__field') && !e.target.closest('.fnd__mount')) {
          Finder.dim(false);
        }
      });

      /* §3.1: tapping the FIELD opens the full-screen overlay below 750.
         There is no separate trigger button any more — the field IS the
         control, which is what the spec and the reference both draw. */
      if (Finder.hero) {
        on(Finder.hero, 'focus', function () {
          if (Finder.returning) { Finder.returning = false; return; }
          if (window.innerWidth < 750) Finder.open();
        });
        /* ⚠️ AND click, which is not belt-and-braces. Closing the overlay
           returns focus to this field, so the field is ALREADY focused —
           tapping it a second time fires no `focus` event at all and the
           overlay would never reopen. Measured: it did not. `open` is a
           no-op when the dialog is already up, so the first tap, which
           fires both, still opens it exactly once. */
        on(Finder.hero, 'click', function () {
          if (window.innerWidth < 750) Finder.open();
        });
      }

      on(document, 'keydown', function (e) {
        if (e.key === 'Escape') Finder.dim(false);
        if (!Finder.isOpen()) return;
        if (e.key === 'Escape') { Finder.close(); return; }
        trapTab(e, Finder.overlay);
      });

      /* The Back button closes the overlay (§3.1). The state is pushed on
         open, so `popstate` here is that entry being popped — closing without
         calling history.back() a second time. */
      on(window, 'popstate', function () {
        if (Finder.isOpen()) Finder.close(true);
      });

      /* The overlay is display:none from 750 up, so a window widened while it
         is open would strand a full-screen dialog over a locked page. 750 is
         the guide's tablet step and the same literal responsive.css uses. */
      if (window.matchMedia) {
        var wide = window.matchMedia('(min-width: 750px)');
        var onWide = function (m) { if (m.matches) Finder.close(); };
        if (wide.addEventListener) wide.addEventListener('change', onWide);
        else if (wide.addListener) wide.addListener(onWide);
      }
    },

    open: function () {
      var o = Finder.overlay;
      if (!o || Finder.isOpen()) return;
      o.setAttribute('data-open', '');
      o.hidden = false;
      o.setAttribute('role', 'dialog');
      o.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('nav-open');   /* locks body scroll */
      if (Finder.input && Finder.hero) Finder.input.value = Finder.hero.value;
      Finder.idle(!Finder.input || Finder.input.value.trim().length < 2);
      /* Back closes it. pushState, not replaceState: this is the one thing on
         the page that SHOULD add a history entry (§3.1). */
      try { window.history.pushState({ tnpFinder: 1 }, ''); } catch (e) { /* ignore */ }
      /* Style recalculation is lazy, so the input is still computed `hidden`
         in this tick and focus() would be silently ignored — the same trap
         CollSheet.open documents. Reading offsetHeight forces the flush. */
      void o.offsetHeight;
      if (Finder.hero) Finder.hero.blur();
      if (Finder.input) Finder.input.focus();
    },

    close: function (fromPop) {
      var o = Finder.overlay;
      if (!o || !Finder.isOpen()) return;
      o.removeAttribute('data-open');
      o.hidden = true;
      o.removeAttribute('role');
      o.removeAttribute('aria-modal');
      document.documentElement.classList.remove('nav-open');
      if (!fromPop) { try { window.history.back(); } catch (e) { /* ignore */ } }
      /* Focus returns to the field that opened it — and `returning` stops
         that focus from opening the overlay straight back up. */
      if (Finder.hero) { Finder.returning = true; Finder.hero.focus(); }
    }
  };
  /* ── Clearance rows — scroller arrows, one pair per open row ─────────────
     Enhancement only, and much smaller than BestTabs above: there are no tabs
     and no panel swap here, because sections/clearance.liquid draws every row
     open. The ONLY thing missing without JS is the arrow pair, so that is all
     this adds. base.css hides the arrows under html.no-js — an arrow that
     cannot scroll is worse than no arrow — and the row itself swipes, snaps
     and keyboard-scrolls either way.

     Deliberately NOT wired through BestTabs. That module stands down when it
     finds no tabs (`if (!tabs.length ...) return`), which is correct for it
     and useless here, and bending it to run tabless would put a tab machine's
     lifecycle behind ten rows that have no tabs.

     ⚠️ GEOMETRY IS READ AT LOAD, ON SCROLL AND ON RESIZE, AND THAT IS ENOUGH
     ONLY BECAUSE EVERY ROW IS LAID OUT. An earlier draft put
     `content-visibility: auto` on every scrollport but the first; a size-
     skipped port reports scrollWidth === clientWidth, so sync() disabled both
     arrows on rows 2-10 and no re-measure recovered them — not an
     IntersectionObserver, and not `contentvisibilityautostatechange`, which
     never fired although the property was supported. The rule is gone (see
     base.css, .cl__port, for the measurement). If it comes back, these arrows
     need their geometry from something other than the skipped element.      */
  var ClearRows = {
    /* Same rule Gallery and BestTabs state: tokens.css zeroes the CSS
       durations under prefers-reduced-motion, but a smooth `scrollBy` is a
       scroll animation and not a transition, so it has to be asked here. */
    motion: function () {
      return (window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches)
        ? 'auto' : 'smooth';
    },

    init: function () {
      $$('[data-cl-row]').forEach(function (row) { ClearRows.wire(row); });
    },

    wire: function (root) {
      var port = $('[data-cl-port]', root);
      var prev = $('[data-cl-prev]', root);
      var next = $('[data-cl-next]', root);
      if (!port || (!prev && !next)) return;

      /* No RTL locale ships today (en, es). Reading direction anyway costs one
         property and keeps the arrows correct if one is ever added — in RTL,
         "next" travels left. */
      var rtl = document.documentElement.getAttribute('dir') === 'rtl' ||
                (root.closest && root.closest('[dir="rtl"]') !== null);

      /* An arrow at the end of its travel is disabled, not hidden — including
         the case that matters most here: a category with fewer reduced
         products than `count` leaves scrollWidth === clientWidth, so both
         arrows go dead and the short row sits still instead of jittering.
         2px of slack because sub-pixel layout means scrollLeft rarely lands
         exactly on 0 or exactly on the maximum. */
      function sync() {
        var max = port.scrollWidth - port.clientWidth;
        var at = Math.abs(port.scrollLeft);
        if (prev) prev.disabled = at <= 2;
        if (next) next.disabled = at >= max - 2;
      }

      /* Scroll by whole cards, never by a guessed fraction of the viewport:
         the pitch is measured from two real slides, so a half card is never
         left hanging at the edge. */
      function paged(dir) {
        var slides = $$('[data-cl-slide]', port);
        if (!slides.length) return;
        var pitch = slides.length > 1
          ? Math.abs(slides[1].getBoundingClientRect().left -
                     slides[0].getBoundingClientRect().left)
          : slides[0].getBoundingClientRect().width;
        if (!pitch) return;
        var by = (rtl ? -dir : dir) *
                 Math.max(1, Math.floor(port.clientWidth / pitch)) * pitch;
        if (port.scrollBy) port.scrollBy({ left: by, behavior: ClearRows.motion() });
        else port.scrollLeft += by;
      }

      on(prev, 'click', function () { paged(-1); });
      on(next, 'click', function () { paged(1); });

      /* A snap scroll fires `scroll` dozens of times; unthrottled, each one
         would measure the port. Same guard the gallery and BestTabs use. */
      var queued = false;
      on(port, 'scroll', function () {
        if (queued) return;
        queued = true;
        raf(function () { queued = false; sync(); });
      });

      /* A rect taken immediately after a resize still describes the previous
         width, so this is a timeout and not a frame callback — the reason
         BestTabs gives for the same 150ms. */
      var resizeTimer = null;
      on(window, 'resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(sync, 150);
      });

      setTimeout(sync, 0);
    }
  };


  /* ── SearchToggle — the phone header's search icon. ──────────────────────
     Mode A gave the phone a full-width search ROW, 46px that is spent whether
     or not anyone is searching. LocoYoko's mobile header spends it only on
     demand: a search ICON that reveals the field. Same pattern here.

     The button carries the state in `aria-expanded` and CSS reacts with
     `:has()`, so there is one source of truth and no class to keep in step.
     Without JS the button simply never expands — and the field is NOT hidden
     in that case, because `:has()` support and JS support travel together
     closely enough that a no-JS visitor on a modern engine still gets the row.
     See responsive.css, which opens the row when `:has()` is unsupported. */
  var SearchToggle = {
    init: function () {
      var btn = document.querySelector('[data-search-toggle]');
      if (!btn) return;
      var field = document.getElementById('header-search');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (!open && field) field.focus();
      });
      /* Esc closes it and returns focus, the same contract the drawer uses. */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (btn.getAttribute('aria-expanded') !== 'true') return;
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      });
    }
  };

  /* ── Accordions — <details>/<summary>, forced open at lg+ via CSS. ─────── */
  var Accordion = { init: function () { /* native; CSS handles lg+ */ } };

  /* ORDER IS LOAD-BEARING in two places. `CollFilters` must initialise BEFORE
     `Filters2`, because it claims #FacetForm and Filters2 stands down when it
     sees that claim. Reversed, every checkbox fires a full reload and a fetch.
     And `HeaderMetrics` goes FIRST, so --header-h is the measured height
     before Finder reads it back off the tab row in Finder.settle.
     Each init is isolated, so one broken module cannot take the others down. */
  document.addEventListener('DOMContentLoaded', function () {
    [HeaderMetrics, Nav, SubscribePopup, SubmitOnce, Qty, CollFilters, Filters2, Cart, Variants,
     Gallery, BestTabs, ClearRows, Recs, Search, Recent, CollView, CollSheet,
     CollMore, CollQuickAdd, CollPrice, CollShowAll, Localization, Wishlist,
     FormErrors, Finder, Accordion, SearchToggle].forEach(function (m) {
      try { m.init(); } catch (e) { console.error('[theme]', e); }
    });
  });
})();
